import request from '@/utils/request'
// 全局
export function uploadImg(param = {}, resParams) {
    //图片上传地址
    return request.customPost(
        '/YmUpload_image',
        param,
        resParams,
        'https://api.yichengshi.cn'
    )
}
export function uploadVideo(param = {}, resParams) {
    //测试视频上传地址
    return request.customPost(
        '/YmUpload_videoFile',
        param,
        resParams,
        'https://api.yichengshi.cn'
    )
}
import axios from 'axios'
export function uploadFile(param, config) {

    let axiosConfig = {
        url: 'https://api.yichengshi.cn/YmUpload_image',
        method: 'post',
        data: param,
    }
    if (config instanceof Object) {
        for (let key in config) {
            axiosConfig[key] = config[key]
        }
    }
    return axios(axiosConfig)
}

export function ssUploadImg(param = {}, resParams) {
    //图片上传地址
    return request.customPost(
        '/edcmanageapi/Shansong_fileUpload',
        param,
        resParams,
        localStorage.baseUrl || 'https://api.yichengshi.cn'
    )
}
//网付退款
export function createReundOrder(param = {}, resParams) {
    //网付退款
    return request.post('/edcmanageapi/Order_refundMallOrder', param, resParams)
}

// 登录注册
export function findImageCaptcha(param = {}, resParams) {
    //图形验证码
    return request.post(
        '/edcmanageapi/ImageCaptca_findImageCaptcha',
        param,
        resParams
    )
}
export function pclogin(param = {}, resParams) {
    //用户登录
    return request.post('/edcmanageapi/Login_pclogin', param, resParams)
}
export function findPassCaptch(param = {}, resParams) {
    //忘记密码发送验证码
    return request.post('/edcmanageapi/Login_findPassCaptcha', param, resParams)
}
export function findPassWord(param = {}, resParams) {
    //忘记密码的情况下修改密码
    return request.post('/edcmanageapi/Login_findPassWord', param, resParams)
}
export function registCaptcha(param = {}, resParams) {
    //用户注册验证码
    return request.post('/edcmanageapi/Login_registCaptcha', param, resParams)
}
export function regist(param = {}, resParams) {
    //用户注册
    return request.post('/edcmanageapi/Login_regist', param, resParams)
}

// 会员
export function getShopMemberCardList(param = {}, resParams) {
    //会员卡列表
    return request.post(
        '/edcmanageapi/ShopMember_shopMemberCardList',
        param,
        resParams
    )
}
export function getShopMemberList(param = {}, resParams) {
    //店铺会员列表
    return request.post(
        '/edcmanageapi/ShopMember_shopMemberList',
        param,
        resParams
    )
}
export function getShopMemberListNum(param = {}, resParams) {
    //店铺会员列表总数
    return request.post(
        '/edcmanageapi/ShopMember_shopMemberList_count',
        param,
        resParams
    )
}
export function getBindWxQrValue(param = {}, resParams) {
    //添加会员--填写用户资料-获取绑定微信二维码
    return request.post(
        '/edcmanageapi/ShopMember_getBindWxQrValue',
        param,
        resParams
    )
}
export function modifyShopMember(param = {}, resParams) {
    //修改会员
    return request.post(
        '/edcmanageapi/ShopMember_modifyShopMember',
        param,
        resParams
    )
}
export function exportExcelMember(param = {}, resParams) {
    //会员导出
    return request.post(
        '/edcmanageapi/ShopMember_exportExcelMember',
        param,
        resParams
    )
}
export function importShopMember(param = {}, resParams) {
    //会员导入
    return request.customPost(
        '/edcmanageapi/ShopMember_importShopMember',
        param,
        resParams
    )
}

// 商品
export function getEdcShopGoodsCategorys(param = {}, resParams) {
    // 获取商品分类
    let params = Object.assign({}, param)
    if (params.level != 2) {
        delete params.level
    }
    return request.post(
        '/edcmanageapi/Shop_getEdcShopGoodsCategorys',
        params,
        resParams
    )
}
export function getFindAllGoodsPlus(param = {}, resParams) {
    //商品列表带规格
    return request.post('/edcmanageapi/Goods_findAllGoodsPlus', param, resParams)
}
export function getFindAllGoods(param = {}, resParams) {
    //商品列表
    return request.post('/edcmanageapi/Goods_findAllGoods', param, resParams)
}
export function getGoodsAllInfo(param = {}, resParams) {
    //商品详情
    return request.post('/edcmanageapi/Goods_goodsAllInfo', param, resParams)
}
export function updateGoods(param = {}, resParams) {
    //添加、更新商品
    return request.post('/edcmanageapi/Goods_updateGoods', param, resParams)
}
export function batchUpdateGoods(param = {}, resParams) {
    //添加、更新商品
    return request.post('/edcmanageapi/Goods_batchUpdateGoods', param, resParams)
}
export function findGoodsNum(param = {}, resParams) {
    //获取商品数量
    return request.post('/edcmanageapi/Goods_findGoodsNum', param, resParams)
}
export function updateEdcGoodsCategory(param = {}, resParams) {
    //添加、更新店铺商品分类
    return request.post(
        '/edcmanageapi/Shop_updateEdcGoodsCategory',
        param,
        resParams
    )
}
export function updateEdcGoodsCategoryDel(param = {}, resParams) {
    //删除商品分类
    return request.post(
        '/edcmanageapi/Shop_updateEdcGoodsCategoryDel',
        param,
        resParams
    )
}
export function batchUpdateGoodsCategorys(param = {}, resParams) {
    //批量 操作 商品分类 删除  排序
    return request.post(
        '/edcmanageapi/Goods_batchUpdateGoodsCategorys',
        param,
        resParams
    )
}
export function codeImage(param = {}, resParams) {
    //餐桌码
    return request.post('/edcmanageapi/Shop_codeImage', param, resParams)
}
export function findAllGoodsSample(param = {}, resParams) {
    //必选商品
    return request.post(
        '/edcmanageapi/Goods_findAllGoodsSample',
        param,
        resParams
    )
}

// 店铺
export function getShopInfo(param = {}, resParams) {
    return request.post('/edcmanageapi/Shop_getShopInfo', param, resParams)
}
export function getShopCategorys(param = {}, resParams) {
    return request.post(
        '/edcmanageapi/Shop_getEdcShopCategorys',
        param,
        resParams
    )
}
// 主动推劵 可选优惠券列表
export function getCashCouponDtosForShoperSend(param = {}, resParams) {
    return request.post(
        '/edcmanageapi/ShopNoticeMessage_findCashCouponDtosForShoperSend',
        param,
        resParams
    )
}
export function getShopNotices(param = {}, resParams) {
    return request.post('/edcmanageapi/Shop_notices', param, resParams)
}
export function getShopNoticeInfo(param = {}, resParams) {
    return request.post('/edcmanageapi/Shop_noticeInfo', param, resParams)
}
export function getShopApplyPayInfo(param = {}, resParams) {
    return request.post('/edcmanageapi/Shop_applyPayInfo', param, resParams)
}
export function setShopIsBusiness(param = {}, resParams) {
    //修改店铺状态
    return request.post('/edcmanageapi/Shop_setShopIsBusiness', param, resParams)
}
export function toSetIsAutoTake(param = {}, resParams) {
    //修改自动接单
    return request.post('/edcmanageapi/Shop_toSetIsAutoTake', param, resParams)
}
export function modifyShopInfo(param = {}, resParams) {
    //修改店铺信息
    return request.post('/edcmanageapi/Shop_modifyShopInfo', param, resParams)
}
export function loginOut(param = {}, resParams) {
    //退出登录
    return request.post('/edcmanageapi/Shop_loginOut', param, resParams)
}
export function modifyPass(param = {}, resParams) {
    //退出登录
    return request.post('/edcmanageapi/Shop_modifyPass', param, resParams)
}
export function submitApplyPay(param = {}, resParams) {
    //申请网付支付  修改店铺信息中的 支付方式时 返回code=11  需要去申请 (还没测试)
    return request.post('/edcmanageapi/Shop_submitApplyPay', param, resParams)
}
export function autoCreateEdcShopTable(param = {}, resParams) {
    //批量自动创建餐桌
    return request.post(
        '/edcmanageapi/Shop_autoCreateEdcShopTable_v3',
        param,
        resParams
    )
}

// 餐桌
export function getShopAreas(param = {}, resParams) {
    // 获取餐桌区域  kk
    return request.post('/edcmanageapi/Shop_getShopAreas', param, resParams)
}
export function getShopAreasNum(param = {}, resParams) {
    // 获取餐桌区域数量  kk
    return request.post('/edcmanageapi/Shop_getShopAreas_count', param, resParams)
}
export function getShopTables(param = {}, resParams) {
    // 获取店铺的所有餐桌 kk
    return request.post('/edcmanageapi/Shop_getShopTables_V3', param, resParams)
}
export function getShopTablesNum(param = {}, resParams) {
    // 获取店铺的所有餐桌数量 kk
    return request.post(
        '/edcmanageapi/Shop_getShopTables_V3_count',
        param,
        resParams
    )
}
export function getShopTableConfigs(param = {}, resParams) {
    //获取餐桌类型列表
    return request.post(
        '/edcmanageapi/Shop_getShopTableConfigs',
        param,
        resParams
    )
}
export function getShopTableConfigsNum(param = {}, resParams) {
    //获取餐桌类型列表数量
    return request.post(
        '/edcmanageapi/Shop_getShopTableConfigs_count',
        param,
        resParams
    )
}
export function delEdcShopTable(param = {}, resParams) {
    //删除 餐桌
    return request.post('/edcmanageapi/Shop_delEdcShopTable', param, resParams)
}
export function updateEdcShopTable(param = {}, resParams) {
    //创建、更新 餐桌
    return request.post(
        '/edcmanageapi/Shop_updateEdcShopTable_v3',
        param,
        resParams
    )
}
export function updateShoppingTableBindCode(param = {}, resParams) {
    //绑定餐桌二维码
    return request.post(
        '/edcmanageapi/Shop_updateShoppingTableBindCode',
        param,
        resParams
    )
}
export function moveShopTables(param = {}, resParams) {
    //移动餐桌
    return request.post('/edcmanageapi/Shop_moveShopTables', param, resParams)
}
export function updateEdcShopTableConfig(param = {}, resParams) {
    //添加、更新餐桌类型
    return request.post(
        '/edcmanageapi/Shop_updateEdcShopTableConfig',
        param,
        resParams
    )
}
export function addTableArea(param = {}, resParams) {
    //创建、更新 餐桌区域
    return request.post('/edcmanageapi/Shop_addTableArea', param, resParams)
}
export function delEdcShopTableConfig(param = {}, resParams) {
    //删除餐桌类型
    return request.post(
        '/edcmanageapi/Shop_delEdcShopTableConfig',
        param,
        resParams
    )
}
export function delTableArea(param = {}, resParams) {
    //创建、更新 餐桌区域
    return request.post('/edcmanageapi/Shop_delTableArea', param, resParams)
}

// 订单
export function getOrderNumsByStatus(param = {}, resParams) {
    // 店铺各个状态的订单数量
    return request.post('/edcmanageapi/Order_orderNumsByStatus', param, resParams)
}
export function getOrderByTable(param = {}, resParams) {
    return request.post('/edcmanageapi/Order_getOrderByTable', param, resParams)
}
export function changeOrderTable(param = {}, resParams) {
    return request.post('/edcmanageapi/Order_changeOrderTable', param, resParams)
}
export function getEasySubOrder(param = {}, resParams) {
    return request.post('/edcmanageapi/Order_easySubOrder', param, resParams)
}
export function subOrder(param = {}, resParams) {
    return request.post('/edcmanageapi/Order_subOrder', param, resParams)
}
export function getStatisticsOrdersByDate(param = {}, resParams) {
    return request.post(
        '/edcmanageapi/Order_statisticsOrdersByDate',
        param,
        resParams
    )
}
export function getAllOrders(param = {}, resParams) {
    // 店铺的订单
    return request.post('/edcmanageapi/Order_allOrders', param, resParams)
}
export function operateOrder(param = {}, resParams) {
    // 操作订单 使用会员卡 打折、赠送、退款、整单退款、整单打折、整单改价 没权限时会报异常 code = 20 需要输入管理员账号密码 获取权限
    return request.post('/edcmanageapi/Order_operateOrder', param, resParams)
}
export function handleOrder(param = {}, resParams) {
    // 处理订单  ---卖家接单、 卖家送货 、卖家同意退款、 卖家拒绝退款、 手动完成订单
    return request.post('/edcmanageapi/Order_handleOrder', param, resParams)
}

// 首页数据
export function getStatisticsOrders(param = {}, resParams) {
    // 订单统计
    return request.post('/edcmanageapi/Order_statisticsOrders', param, resParams)
}
export function getStatisticsOrdersToday(param = {}, resParams) {
    // 今日订单统计
    return request.post(
        '/edcmanageapi/Order_statisticsOrdersToday',
        param,
        resParams
    )
}
export function getStatisticsCommentNum(param = {}, resParams) {
    // 评论数统计
    return request.post(
        '/edcmanageapi/Customer_statisticsCommentNum',
        param,
        resParams
    )
}
export function getMemberStatistic(param = {}, resParams) {
    // 新增会员数据和全部会员数据
    return request.post(
        '/edcmanageapi/Order_getMemberStatistic',
        param,
        resParams
    )
}
export function getFindTop5Goods(param = {}, resParams) {
    // 月销售排名商品
    return request.post('/edcmanageapi/Goods_findTop5Goods', param, resParams)
}
export function setTableEmpty(param = {}, resParams) {
    // 清除桌位
    return request.post('/edcmanageapi/Shop_setTableEmpty', param, resParams)
}
export function findTopGoods(param = {}, resParams) {
    // 总月销售排名商品
    return request.post('/edcmanageapi/Goods_findTopGoodsV2', param, resParams)
}
export function findTopGoodsListCount(param = {}, resParams) {
    // 总月销售count
    return request.post(
        '/edcmanageapi/Goods_findTopGoodsListCountV2',
        param,
        resParams
    )
}
export function findGoodsSale(param = {}, resParams) {
    // 获取统计赠菜及所有的商品销售数据
    return request.post('/edcmanageapi/Goods_findGoodsSale', param, resParams)
}
export function findGoodsSaleListCount(param = {}, resParams) {
    // 获取统计赠菜及所有的商品销售数据count
    return request.post(
        '/edcmanageapi/Goods_findGoodsCountSale',
        param,
        resParams
    )
}
export function findTheGoodSales(param = {}, resParams) {
    // 获取某商品 销售情况
    return request.post('/edcmanageapi/Goods_findTheGoodSales', param, resParams)
}
export function findTheGoodSalesCount(param = {}, resParams) {
    // 获取某商品 销售情况记录数
    return request.post('/edcmanageapi/Goods_findTheGoodSalesCount', param, resParams)
}

// 打印机设置
export function getPrintRules(param = {}, resParams) {
    // 普通打印规则列表
    return request.post('/edcmanageapi/Print_printRules', param, resParams)
}
export function savePrintRule(param = {}, resParams) {
    // 新增编辑打印规则
    return request.post('/edcmanageapi/Print_savePrintRule', param, resParams)
}
export function delPrintRule(param = {}, resParams) {
    // 删除打印规则
    return request.post('/edcmanageapi/Print_delPrintRules', param, resParams)
}
export function getCountPrintRules(param = {}, resParams) {
    // 统计规则数量  分页使用
    return request.post('/edcmanageapi/Print_countPrintRules', param, resParams)
}
export function getPrinterDevices(param = {}, resParams) {
    // 所有打印机记录
    return request.post('/edcmanageapi/Printer_printerDevices', param, resParams)
}
export function getPrintTempConfig(param = {}, resParams) {
    // 打印模板编辑
    return request.post(
        '/edcmanageapi/Print_getPrintTempConfig',
        param,
        resParams
    )
}
export function setPrintTempConfig(param = {}, resParams) {
    // 保存模板编辑
    return request.post(
        '/edcmanageapi/Print_setPrintTempConfig',
        param,
        resParams
    )
}
export function batchSaveLocalPrint(param = {}, resParams) {
    // 批量上传本地打印机记录
    return request.post(
        '/edcmanageapi/Printer_batchSaveLocalPrint',
        param,
        resParams
    )
}
export function getPrintContentForPc(param = {}, resParams) {
    // 商家打印模板html
    return request.post(
        '/edcmanageapi/Print_getPrintContentForPc',
        param,
        resParams
    )
}
export function findShopTemplate(param = {}, resParams) {
    // 商家打印模板html
    return request.pushPost(
        '/edcmanageapi/Shop_findShopTemplate',
        param,
        resParams
    )
}
export function printOrder(param = {}, resParams) {
    //打印订单
    return request.post('/edcmanageapi/Printer_printOrder', param, resParams)
}
export function delPrinterDevices(param = {}, resParams) {
    //删除打印机记录
    return request.post(
        '/edcmanageapi/Printer_delPrinterDevices',
        param,
        resParams
    )
}
export function addPrinterDevice(param = {}, resParams) {
    //连接上打印机 只是编辑
    return request.post(
        '/edcmanageapi/Printer_addPrinterDevice',
        param,
        resParams
    )
}
export function toSetPrintType(param = {}, resParams) {
    //切换打印功能  1普通 2分单
    return request.post('/edcmanageapi/Shop_toSetPrintType', param, resParams)
}

// 营销管理
export function getFuncList(param = {}, resParams) {
    // 获取已购的订单List
    return request.post('/edcmanageapi/UserFunc_getFuncList', param, resParams)
}
export function getUserFuncProductList(param = {}, resParams) {
    //查询所有可购买的功能
    return request.post(
        '/edcmanageapi/UserFunc_findUserFuncProductList',
        param,
        resParams
    )
}
export function buyUserFunc(param = {}, resParams) {
    //购买step1:选择产品 进行购买
    return request.post('/edcmanageapi/UserFunc_buyUserFunc', param, resParams)
}
export function getTransactionInfo(param = {}, resParams) {
    // step2:获取交易信息  //step3: 跳页面https://api.163.gg/pay/WebWfOrder_userPay?tranOrderId=(填入获取到的tranOrderId) -》显示付款二维码 // 测试 使用 edcmanageapi/UserFunc_testQR?tranOrderId= 显示付款码  扫码 即付款
    return request.post(
        '/edcmanageapi/UserFunc_getTransactionInfo',
        param,
        resParams
    )
}

// 文件导入
export function importGoodsNum(param = {}, resParams) {
    //excel导入商品 Form-data的形式
    return request.customPost(
        '/edcmanageapi/Goods_importGoodsNum',
        param,
        resParams
    )
}
export function importGoodsCategory(param = {}, resParams) {
    //excel导入商品类别 Form-data的形式
    return request.customPost(
        '/edcmanageapi/Goods_importGoodsCategory',
        param,
        resParams
    )
}

// 顾客\评论
export function getCustomerComments(param = {}, resParams) {
    //评论列表
    return request.post(
        '/edcmanageapi/Customer_customerComments',
        param,
        resParams
    )
}
export function getStatisticsComments(param = {}, resParams) {
    //评论统计
    return request.post(
        '/edcmanageapi/Customer_statisticsComments',
        param,
        resParams
    )
}
export function delReplyByShoper(param = {}, resParams) {
    //删除卖家评论
    return request.post(
        '/edcmanageapi/Customer_delReplyByShoper',
        param,
        resParams
    )
}
export function delCommentsByShoper(param = {}, resParams) {
    //删除评论
    return request.post(
        '/edcmanageapi/Customer_delCommentsByShoper',
        param,
        resParams
    )
}
export function replyByShoper(param = {}, resParams) {
    //卖家回复评论
    return request.post('/edcmanageapi/Customer_replyByShoper', param, resParams)
}

// 权限设置
export function findShopWorks(param = {}, resParams) {
    //获取员工列表
    return request.post('/edcmanageapi/Shop_findShopWorks', param, resParams)
}
export function getMdcAuths(param = {}, resParams) {
    //获取权限列表
    return request.post('/edcmanageapi/Shop_getMdcAuths', param, resParams)
}
export function findMdcAuthsByUser(param = {}, resParams) {
    //获取员工的权限列表
    return request.post('/edcmanageapi/Shop_findMdcAuthsByUser', param, resParams)
}
export function batchSetMdcAuth(param = {}, resParams) {
    //批量设置员工权限
    return request.post('/edcmanageapi/Shop_batchSetMdcAuth', param, resParams)
}

// 达达快递设置
export function getMerchant(param = {}, resParams) {
    //获取商家  只有1家
    return request.post('/edcmanageapi/Dada_getMerchant', param, resParams)
}
// 闪送快递设置
export function getShansongMerchant(param = {}, resParams) {
    //获取商家  只有1家
    return request.post('/edcmanageapi/Shansong_getStore', param, resParams)
}

export function addMYTMerchant(param = {}, resParams) {
    //新增麦芽田商户
    return request.post('/edcmanageapi/Maiyatian_addMerchant', param, resParams)
}
export function addMerchant(param = {}, resParams) {
    //绑定新增商家
    return request.post('/edcmanageapi/Dada_addMerchant', param, resParams)
}
export function addSSMerchant(param = {}, resParams) {
    //绑定新增商家-闪送
    return request.post('/edcmanageapi/Shansong_addMerchant', param, resParams)
}
export function reAddSSMerchant(param = {}, resParams) {
    //重新绑定新增商家-闪送
    return request.post('/edcmanageapi/Shansong_reAddMerchant', param, resParams)
}

export function getMerchantForCheck(param = {}, resParams) {
    //是否绑定商家
    return request.post(
        '/edcmanageapi/Dada_getMerchantForCheck',
        param,
        resParams
    )
}
export function getShansongMerchantForCheck(param = {}, resParams) {
    //是否绑定商家
    return request.post(
        '/edcmanageapi/Shansong_getMerchant',
        param,
        resParams
    )
}

export function bindMerchant(param = {}, resParams) {
    //绑定已存在商家
    return request.post('/edcmanageapi/Dada_bindMerchant', param, resParams)
}
export function addShop(param = {}, resParams) {
    //绑定新增门店
    return request.post('/edcmanageapi/Dada_addShop', param, resParams)
}
export function addSSShop(param = {}, resParams) {
    //绑定新增门店-闪送
    return request.post('/edcmanageapi/Shansong_addOrUpdateShop', param, resParams)
}
export function bindShop(param = {}, resParams) {
    //绑定已存在门店
    return request.post('/edcmanageapi/Dada_bindShop', param, resParams)
}
export function bindSSShop(param = {}, resParams) {
    //绑定已存在门店-闪送
    return request.post('/edcmanageapi/Shansong_bindShop', param, resParams)
}
export function getBusiness(param = {}, resParams) {
    //获取业务类型Array
    return request.post('/edcmanageapi/Dada_getBusiness', param, resParams)
}
export function getShansongBusiness(param = {}, resParams) {
    //获取业务类型Array
    return request.post('/edcmanageapi/Shansong_goodsType', param, resParams)
}
export function getMYTBusiness(param = {}, resParams) {
    //获取业务类型Array
    return request.post('/edcmanageapi/Maiyatian_getBusiness', param, resParams)
}
export function updateShop(param = {}, resParams) {
    //更新商户信息
    return request.post('/edcmanageapi/Dada_updateShop', param, resParams)
}
export function updateMYTShop(param = {}, resParams) {
    //修改麦芽田商户
    return request.post('/edcmanageapi/Maiyatian_updateMerchant', param, resParams)
}
export function updateShopUnbind(param = {}, resParams) {
    //解绑门店
    return request.post('/edcmanageapi/Dada_updateShopUnbind', param, resParams)
}
// 叫号排队系统
export function getLineUpType(param = {}, resParams) {
    //餐桌类型带 排队和空桌数据
    return request.post('/edcmanageapi/Shop_getLineUpType', param, resParams)
}
export function getLineUpList(param = {}, resParams) {
    //每个餐桌类型下的排队
    return request.post('/edcmanageapi/Shop_getLineUpList', param, resParams)
}
export function addLineUp(param = {}, resParams) {
    //增加排队记录
    return request.post('/edcmanageapi/Shop_addLineUp', param, resParams)
}
export function callLineUp(param = {}, resParams) {
    //叫号
    return request.post('/edcmanageapi/Shop_callLineUp', param, resParams)
}
export function jumpLineUp(param = {}, resParams) {
    //过号
    return request.post('/edcmanageapi/Shop_jumpLineUp', param, resParams)
}
export function getLineUpById(param = {}, resParams) {
    //获取单个排队信息
    return request.post('/edcmanageapi/Shop_getLineUpById', param, resParams)
}
export function getAppointmentList(param = {}, resParams) {
    //预约列表
    return request.post('/edcmanageapi/Shop_getAppointmentList', param, resParams)
}
export function updateAppointment(param = {}, resParams) {
    //更新预约状态
    return request.post('/edcmanageapi/Shop_updateAppointment', param, resParams)
}
export function addAppointments(param = {}, resParams) {
    //增加预约
    return request.post('/edcmanageapi/Shop_addAppointments', param, resParams)
}

export function authorizeView(param = {}, resParams) {
    //店铺授权小程序 跳转授权页面
    return request.post(
        '/miniProgram/MiniAppAuth_getAuthorizeViewUrl',
        param,
        resParams
    )
}

export function authorizeViewAlipay(param = {}, resParams) {
    //店铺授权支付宝小程序 跳转授权页面
    return request.post(
        '/miniProgram/AlipayMiniAppAction_getAuthUrl',
        param,
        resParams
    )
}

export function authorizeViewDY(param = {}, resParams) {
    //获取抖音小程序授权链接接口地址
    return request.post(
        '/miniProgram/DyMiniAppAuth_getAuthorizeViewUrl',
        param,
        resParams
    )
}


export function getMiniAppInfo(param = {}, resParams) {
    //获取小程序信息
    return request.post(
        '/miniProgram/MiniAppAuth_getMiniAppInfo',
        param,
        resParams
    )
}

export function getMiniAppInfoAlipay(param = {}, resParams) {
    //获取支付宝小程序信息
    return request.post(
        '/miniProgram/AlipayMiniAppAction_getAlipayMiniAppInfo',
        param,
        resParams
    )
}

export function getDYMiniAppInfo(param = {}, resParams) {
    //获取抖音小程序信息
    return request.post(
        '/miniProgram/DyMiniAppAuth_getMiniAppInfo',
        param,
        resParams
    )
}

export function updateMiniAppInfo(param = {}, resParams) {
    //更新小程序信息
    return request.post(
        '/miniProgram/MiniAppAuth_updateMiniAppInfo',
        param,
        resParams
    )
}
export function updateMiniAppInfoAlipay(param = {}, resParams) {
    //更新支付宝小程序信息
    return request.post(
        '/miniProgram/AlipayMiniAppAction_updateAlipayAppletInfo',
        param,
        resParams
    )
}
export function updateDYMiniAppInfo(param = {}, resParams) {
    //更新抖音小程序信息
    return request.post(
        '/miniProgram/DyMiniAppAuth_updateMiniAppInfo',
        param,
        resParams
    )
}
export function getShopAddressList(param = {}, resParams) {
    //商家提货地址列表
    return request.post('/edcmanageapi/Shop_shopAddressList', param, resParams)
}
export function addShopAddress(param = {}, resParams) {
    //增加提货地址
    return request.post('/edcmanageapi/Shop_addShopAddress', param, resParams)
}
export function editShopAddress(param = {}, resParams) {
    //编辑提货地址 或者审核
    return request.post('/edcmanageapi/Shop_editShopAddress', param, resParams)
}
export function delShopAddress(param = {}, resParams) {
    //删除提货地址
    return request.post('/edcmanageapi/Shop_delShopAddress', param, resParams)
}

export function miniAppProduceRelease(param = {}, resParams) {
    //发布
    return request.post('/miniProgram/MiniAppProduce_release', param, resParams)
}

export function miniAppProduceReleaseAlipay(param = {}, resParams) {
    //支付宝发布
    return request.post('/miniProgram/AlipayMiniAppAction_online', param, resParams)
}


export function miniAppProduceReleaseDY(param = {}, resParams) {
    //抖音小程序发布代码
    return request.post('/miniProgram/DyMiniAppProduce_release', param, resParams)
}

export function getApplitTemplateList(param = {}, resParams) {
    //获取可用模板列表
    return request.post(
        '/miniProgram/MiniAppProduce_templateList',
        param,
        resParams
    )
}

export function selectedTemplate(param = {}, resParams) {
    //选择模板并提交代码
    return request.post(
        '/miniProgram/MiniAppProduce_selectedTemplate',
        param,
        resParams
    )
}

export function selectedTemplateAlipay(param = {}, resParams) {
    //选择模板并提交代码支付宝
    return request.post(
        '/miniProgram/AlipayMiniAppAction_selectAndUpload',
        param,
        resParams
    )
}

export function selectedTemplateDY(param = {}, resParams) {
    //选择抖音小程序模板并提交代码
    return request.post(
        '/miniProgram/DyMiniAppProduce_selectedTemplate',
        param,
        resParams
    )
}

export function experienceCreateAlipay(param = {}, resParams) {
    //生成体验小程序
    return request.post(
        '/miniProgram/AlipayMiniAppAction_experienceCreate',
        param,
        resParams
    )
}

export function findAuditStatus(param = {}, resParams) {
    //查询小程序审核状态
    return request.post(
        '/miniProgram/MiniAppProduce_findAuditStatus',
        param,
        resParams
    )
}

export function submitAudit(param = {}, resParams) {
    //提交审核
    return request.post(
        '/miniProgram/MiniAppProduce_submitAudit',
        param,
        resParams
    )
}

export function submitAuditAlipay(param = {}, resParams) {
    //提交审核支付宝
    return request.post(
        '/miniProgram/AlipayMiniAppAction_auditApply',
        param,
        resParams
    )
}
export function submitAuditDY(param = {}, resParams) {
    //抖音小程序提交审核
    return request.post(
        '/miniProgram/DyMiniAppProduce_submitAudit',
        param,
        resParams
    )
}

export function undocodeaudit(param = {}, resParams) {
    //撤销审核
    return request.post(
        '/miniProgram/MiniAppProduce_undocodeaudit',
        param,
        resParams
    )
}

export function undocodeauditAlipay(param = {}, resParams) {
    //撤销审核支付宝
    return request.post(
        '/miniProgram/AlipayMiniAppAction_auditCancel',
        param,
        resParams
    )
}

export function undocodeauditDY(param = {}, resParams) {
    //抖音小程序撤销审核
    return request.post(
        '/miniProgram/DyMiniAppProduce_undocodeaudit',
        param,
        resParams
    )
}

export function bindtester(param = {}, resParams) {
    //绑定体验者
    return request.post(
        '/miniProgram/MiniAppProduce_bindtester',
        param,
        resParams
    )
}
export function bindtesterAlipay(param = {}, resParams) {
    //绑定体验者支付宝
    return request.post(
        '/miniProgram/AlipayMiniAppAction_membersCreate',
        param,
        resParams
    )
}

export function unbindtester(param = {}, resParams) {
    //解绑体验者
    return request.post(
        '/miniProgram/MiniAppProduce_unbindtester',
        param,
        resParams
    )
}

export function unbindtesterAlipay(param = {}, resParams) {
    //解绑体验者支付宝
    return request.post(
        '/miniProgram/AlipayMiniAppAction_membersDelete',
        param,
        resParams
    )
}

export function membersQuery(param = {}, resParams) {
    //小程序应用查询成员列表
    return request.post(
        '/miniProgram/AlipayMiniAppAction_membersQuery',
        param,
        resParams
    )
}

export function getEleOrderShipDetail(param = {}, resParams) {
    //蜂鸟快递信息
    return request.post(
        '/edcmanageapi/Ship_getEleOrderDetail',
        param,
        resParams
    )
}

export function getDeliveryStatusLogMYT(param = {}, resParams) {
    //蜂鸟快递信息
    return request.post(
        '/edcmanageapi/Maiyatian_getDeliveryStatusLog',
        param,
        resParams
    )
}

export function createEleOrder(param = {}, resParams) {
    //手动创建运送订单
    return request.post(
        '/edcmanageapi/Ship_createEleOrder',
        param,
        resParams
    )
}
export function manualIssuance(param = {}, resParams) {
    //手动创建运送订单
    return request.post(
        '/edcmanageapi/Maiyatian_manualIssuance',
        param,
        resParams
    )
}

export function getShopInfoEle(param = {}, resParams) {
    //获取蜂鸟认证信息
    return request.post(
        '/edcmanageapi/Ship_getShopInfo',
        param,
        resParams
    )
}

export function getAuthUrl(param = {}, resParams) {
    //获取认证链接
    return request.post(
        '/edcmanageapi/Ship_getAuthUrl',
        param,
        resParams
    )
}

export function getWxCode(param = {}, resParams) {
    //小程序生成跳转支付页面二维码
    return request.post(
        '/miniProgram/MiniAppProduce_getWxCode',
        param,
        resParams
    )
}

export function createPayUrl(param = {}, resParams) {
    //小程序生成跳转支付页面二维码
    return request.post(
        '/miniProgram/AlipayMiniAppAction_createPayUrl',
        param,
        resParams
    )
}

export function getCardScoreList(param = {}, resParams) {
    //会员积分
    return request.post(
        '/edcmanageapi/CardCoupon_cardScoreList',
        param,
        resParams
    )
}

export function getCashCouponList(param = {}, resParams) {
    //获取优惠券列表
    return request.post(
        '/edcmanageapi/CardCoupon_cashCouponList',
        param,
        resParams
    )
}

export function addPublishCashCoupon(param = {}, resParams) {
    //增加优惠券
    return request.post(
        '/edcmanageapi/CashCoupon_publishCashCoupon',
        param,
        resParams
    )
}

export function offCashCouponUsedDetail(param = {}, resParams) {
    //停用单个券种类
    return request.post(
        '/edcmanageapi/CashCoupon_stopCashCoupon',
        param,
        resParams
    )
}

export function cashCouponUsedDetailList(param = {}, resParams) {
    //营销统计列表
    return request.post(
        '/edcmanageapi/CardCoupon_cashCouponUsedDetailList',
        param,
        resParams
    )
}

export function singleCashCouponUsedDetail(param = {}, resParams) {
    //单个券种类使用列表
    return request.post(
        '/edcmanageapi/CardCoupon_cashCouponUsedDetail',
        param,
        resParams
    )
}
export function findCashCouponBatchOrderBean(param = {}, resParams) {
    //根据优惠券批次id获取批次信息
    return request.post(
        '/edcmanageapi/CashCoupon_findCashCouponBatchOrderBean',
        param,
        resParams
    )
}

export function getCashCouponUnionList(param = {}, resParams) {
    //联盟优惠券列表
    return request.post(
        '/edcmanageapi/CardCoupon_cashCouponUnionList',
        param,
        resParams
    )
}

export function deleteToShopCouponUnion(param = {}, resParams) {
    // 删除联盟优惠券
    return request.post(
        '/edcmanageapi/CardCoupon_deleteToShopCouponUnion',
        param,
        resParams
    )
}

export function removeShopMember(param = {}, resParams) {
    // 会员删除
    return request.post(
        '/edcmanageapi/ShopMember_removeShopMember',
        param,
        resParams
    )
}

export function deleteCashCoupon(param = {}, resParams) {
    // 优惠券删除
    return request.post(
        '/edcmanageapi/CashCoupon_deleteCashCoupon',
        param,
        resParams
    )
}

export function getRechargeList(param = {}, resParams) {
    // 会员活动列表
    return request.post(
        '/edcmanageapi/Member_rechargeList',
        param,
        resParams
    )
}

export function stopRecharge(param = {}, resParams) {
    // 暂停活动
    return request.post(
        '/edcmanageapi/Member_stopRecharge',
        param,
        resParams
    )
}

export function deleteRecharge(param = {}, resParams) {
    // 删除活动
    return request.post(
        '/edcmanageapi/Member_deleteRecharge',
        param,
        resParams
    )
}

export function updateRecharge(param = {}, resParams) {
    // 增加活动
    return request.post(
        '/edcmanageapi/Member_updateRecharge',
        param,
        resParams
    )
}

export function getAddShopCouponUnionList(param = {}, resParams) {
    // 联盟商户优惠券列表
    return request.post(
        '/edcmanageapi/CardCoupon_getAddShopCouponUnionList',
        param,
        resParams
    )
}

export function addToShopCouponUnion(param = {}, resParams) {
    // 增加商家联盟券到橱窗
    return request.post(
        '/edcmanageapi/CardCoupon_addToShopCouponUnion',
        param,
        resParams
    )
}

export function getExpressCompany(param = {}, resParams) {
    //物流列表
    return request.post(
        '/edcmanageapi/Order_expressCompany',
        param,
        resParams
    )
}

export function sendDSOrder(param = {}, resParams) {
    //订单发货
    return request.post(
        '/edcmanageapi/Order_sendDSOrder',
        param,
        resParams
    )
}

export function sendOrder(param = {}, resParams) {
    //订单批量发货
    return request.post(
        '/edcmanageapi/Order_sendOrder',
        param,
        resParams
    )
}

export function orderExpress(param = {}, resParams) {
    //订单发货
    return request.post(
        '/edcmanageapi/Order_orderExpress',
        param,
        resParams
    )
}

export function exportExcelOrderdetails(param = {}, resParams) {
    //导出订单
    return request.post(
        '/edcmanageapi/Order_exportExcelOrderdetails',
        param,
        resParams
    )
}

export function exportOrder(param = {}, resParams) {
    //导出订单
    return request.post(
        '/edcmanageapi/Order_exportOrder',
        param,
        resParams
    )
}

export function setIslive(param = {}, resParams) {
    //是否带直播
    return request.post(
        '/miniProgram/MiniAppProduce_setIslive',
        param,
        resParams
    )
}
export function rechargeConsumList(param = {}, resParams) {
    // 会员消费明细
    return request.post(
        '/edcmanageapi/Member_rechargeConsumList',
        param,
        resParams
    )
}
export function modifyShopType(param = {}, resParams) {
    // 修改店铺类型
    return request.post(
        '/edcmanageapi/Shop_modifyShopType',
        param,
        resParams
    )
}

export function memberCardMessage(param = {}, resParams) {
    // 会员卡详情和颜色
    return request.post(
        '/edcmanageapi/Member_memberCardMessage',
        param,
        resParams
    )
}


export function updateMemberCard(param = {}, resParams) {
    // 更新会员卡
    return request.post(
        '/edcmanageapi/Member_updateMemberCard',
        param,
        resParams
    )
}


export function createMemberCard(param = {}, resParams) {
    // 新增会员卡
    return request.post(
        '/edcmanageapi/Member_createMemberCard',
        param,
        resParams
    )
}

export function testMsg(param = {}, resParams) {
    // 消息上报
    return request.testGet(
        '/api/index/test',
        param,
        resParams
    )
}


export function getUnNotifiedOrders(param = {}, resParams) {
    // 获取未打印订单
    return request.post(
        '/edcmanageapi/Order_getUnNotify',
        param,
        resParams
    )
}


export function setIsNotified(param = {}, resParams) {
    // 标记成功接收通知
    return request.post(
        '/edcmanageapi/Order_setIsNotified',
        param,
        resParams
    )
}


export function modifyPushInfo(param = {}, resParams) {
    // 修改推送ChannelId
    return request.post(
        '/edcmanageapi/Login_modifyPushInfo',
        param,
        resParams
    )
}

export function CustomServiceList(param = {}, resParams) {
    // 自定义服务列表
    return request.post(
        '/edcmanageapi/CustomService_serviceList',
        param,
        resParams
    )
}

export function delCustomServiceList(param = {}, resParams) {
    // 删除服务
    return request.post(
        '/edcmanageapi/CustomService_delService',
        param,
        resParams
    )
}

export function saveOrUpdateService(param = {}, resParams) {
    // 添加/修改服务
    return request.post(
        '/edcmanageapi/CustomService_saveOrUpdateService',
        param,
        resParams
    )
}

export function getImgList(param = {}, resParams) {
    // 图片列表
    return request.post(
        '/edcmanageapi/UserImageBox_getImgList',
        param,
        resParams
    )
}

export function imgListTotalNum(param = {}, resParams) {
    // 图片列表分页
    return request.post(
        '/edcmanageapi/UserImageBox_imgListTotalNum',
        param,
        resParams
    )
}

export function getTagsList(param = {}, resParams) {
    // 标签列表
    return request.post(
        '/edcmanageapi/UserImageBox_tagsList',
        param,
        resParams
    )
}

export function updateTag(param = {}, resParams) {
    // 修改标签
    return request.post(
        '/edcmanageapi/UserImageBox_updateTag',
        param,
        resParams
    )
}

export function removeTag(param = {}, resParams) {
    // 删除标签
    return request.post(
        '/edcmanageapi/UserImageBox_removeTag',
        param,
        resParams
    )
}

export function addTag(param = {}, resParams) {
    // 添加标签
    return request.post(
        '/edcmanageapi/UserImageBox_addTag',
        param,
        resParams
    )
}

export function removeImg(param = {}, resParams) {
    // 删除图片
    return request.post(
        '/edcmanageapi/UserImageBox_removeImg',
        param,
        resParams
    )
}

export function removeImgBatch(param = {}, resParams) {
    // 批量删除图片
    return request.post(
        '/edcmanageapi/UserImageBox_removeImgBatch',
        param,
        resParams
    )
}

export function moveImg(param = {}, resParams) {
    // 改变图片对应的标签
    return request.post(
        '/edcmanageapi/UserImageBox_moveImg',
        param,
        resParams
    )
}

export function addImg(param = {}, resParams) {
    // 添加图片
    return request.post(
        '/edcmanageapi/UserImageBox_addImg',
        param,
        resParams
    )
}

export function getDeliverySettingListFree(param = {}, resParams) {
    // 获取运费模板列表(带包邮)
    return request.post(
        '/edcmanageapi/Delivery_getDeliverySettingListFree',
        param,
        resParams
    )
}
export function getProvincesAll(param = {}, resParams) {
    // 获取所有省份
    return request.post(
        '/edcmanageapi/Delivery_getProvincesAll',
        param,
        resParams
    )
}

export function getDeliveryList(param = {}, resParams) {
    // 获取运费列表
    return request.post(
        '/edcmanageapi/Delivery_getDeliverySettingList',
        param,
        resParams
    )
}

export function getDeliverySettingRule(param = {}, resParams) {
    // 获取运费规则
    return request.post(
        '/edcmanageapi/Delivery_getDeliverySettingRule',
        param,
        resParams
    )
}

export function addAndUpdateDelivery(param = {}, resParams) {
    // 添加或修改运费模板
    return request.post(
        '/edcmanageapi/Delivery_addAndUpdateDelivery',
        param,
        resParams
    )
}

export function deleteDeliverySettingRule(param = {}, resParams) {
    // 删除运费模板
    return request.post(
        '/edcmanageapi/Delivery_deleteDeliverySettingRule',
        param,
        resParams
    )
}

export function Marketing_activityList(param = {}, resParams) {
    // 活动列表   拼团
    return request.post(
        '/edcmanageapi/Marketing_activityList',
        param,
        resParams
    )
}

export function getLifePayInstitutionList(param = {}, resParams) {
    // 机构列表
    return request.post(
        '/edcmanageapi/LifePay_lifePayInstitutionList',
        param,
        resParams
    )
}
export function getActivityListTotalNum(param = {}, resParams) {
    // 活动列表总记录数
    return request.post(
        'edcmanageapi/Marketing_activityListTotalNum',
        param,
        resParams
    )
}

export function getLifePayInstitutions(param = {}, resParams) {
    // 简易机构列表-用于下拉显示
    return request.post(
        '/edcmanageapi/LifePay_getLifePayInstitutions',
        param,
        resParams
    )
}
export function getuserActivityList(param = {}, resParams) {
    // 用户活动列表
    return request.post(
        'edcmanageapi/Marketing_userActivityList',
        param,
        resParams
    )
}

export function getLifePayInstitutionListCount(param = {}, resParams) {
    // 机构列表-记录数
    return request.post(
        '/edcmanageapi/LifePay_lifePayInstitutionListCount',
        param,
        resParams
    )
}
export function getLifePayInstitutionTemplates(param = {}, resParams) {
    // 获取机构模板
    return request.post(
        '/edcmanageapi/LifePay_getLifePayInstitutionTemplates',
        param,
        resParams
    )
}
export function getShopStores(param = {}, resParams) {
    // 获取商户的门店列表
    return request.post(
        '/edcmanageapi/LifePay_getShopStores',
        param,
        resParams
    )
}
export function getLifePayInstitutionQrCode(param = {}, resParams) {
    // 机构收款码 图片地址
    let sessionId = localStorage.getItem('sessionId')
    let userId = localStorage.getItem('userId')
    return request.baseUrl +
        '/edcmanageapi/LifePay_lifePayInstitutionQrCode?lifePayInstitutionId=' + param.lifePayInstitutionId + '&sessionId=' + sessionId + "&userId=" + userId
}
export function exportExcelOrder(param = {}, resParams) {
    // 导出excel
    let sessionId = localStorage.getItem('sessionId')
    let userId = localStorage.getItem('userId')
    let paramNames = Object.keys(param)
    let url = request.baseUrl +
        '/edcmanageapi/LifePay_exportExcelOrder?sessionId=' + sessionId + "&userId=" + userId;
    paramNames.forEach(val => {
        if (param[val]) {
            url += `&${val}=${param[val]}`
        }
    })
    return url
}
export function addLifePayInstitution(param = {}, resParams) {
    // 添加缴费机构
    return request.post(
        '/edcmanageapi/LifePay_addLifePayInstitution',
        param,
        resParams
    )
}

export function getUserActivityListTotalNum(param = {}, resParams) {
    // 用户活动列表总记录数
    return request.post(
        'edcmanageapi/Marketing_userActivityListTotalNum',
        param,
        resParams
    )
}

export function getLifePayBatchList(param = {}, resParams) {
    // 项目列表（lifePayInstitutionType=300时不显示修改按钮）
    return request.post(
        '/edcmanageapi/LifePay_lifePayBatchList',
        param,
        resParams
    )
}
export function addOrUpdateActivity(param = {}, resParams) {
    // 添加或更新活动  团购
    return request.post(
        'edcmanageapi/Marketing_addOrUpdateActivity',
        param,
        resParams
    )
}

export function getLifePayBatchListtCount(param = {}, resParams) {
    //项目列表-记录数
    return request.post(
        '/edcmanageapi/LifePay_lifePayBatchListCount',
        param,
        resParams
    )
}
export function deleteActivity(param = {}, resParams) {
    // 删除活动  团购
    return request.post(
        'edcmanageapi/Marketing_deleteActivity',
        param,
        resParams
    )
}

export function updatedLifePayBatchEnable(param = {}, resParams) {
    // 设置项目状态
    return request.post(
        '/edcmanageapi/LifePay_updatedLifePayBatchEnable',
        param,
        resParams
    )
}
export function getSingleActivityList(param = {}, resParams) {
    // 活动详情 团购
    return request.post(
        'edcmanageapi/Marketing_singleActivity',
        param,
        resParams
    )
}

export function uploadExcel(param = {}, resParams) {
    // 上传缴费列表（excel 文件）
    return request.customPost(
        '/edcmanageapi/LifePay_uploadExcel',
        param,
        resParams,
        request.baseUrl
    )
}
export function addLifePayBatch(param = {}, resParams) {
    // 添加项目
    return request.post(
        '/edcmanageapi/LifePay_addLifePayBatch',
        param,
        resParams
    )
}
export function getMarketingSingOrder(param = {}, resParams) {
    // 订单详情 团购
    return request.post(
        'edcmanageapi/Marketing_singOrder',
        param,
        resParams
    )
}
export function updateLifePayBatch(param = {}, resParams) {
    // 修改项目
    return request.post(
        '/edcmanageapi/LifePay_updateLifePayBatch',
        param,
        resParams
    )
}

export function isRecommendActivity(param = {}, resParams) {
    // 是否推荐活动 团购
    return request.post(
        'edcmanageapi/Marketing_isRecommendActivity',
        param,
        resParams
    )
}
export function getLifePayOrderList(param = {}, resParams) {
    // 账单列表
    return request.post(
        '/edcmanageapi/LifePay_lifePayOrderList',
        param,
        resParams
    )
}

export function getUserActivityOrderList(param = {}, resParams) {
    // 订单列表 团购
    return request.post(
        'edcmanageapi/Marketing_userActivityOrderList',
        param,
        resParams
    )
}
export function getLifePayOrderListCount(param = {}, resParams) {
    // 账单列表-記錄數
    return request.post(
        '/edcmanageapi/LifePay_lifePayOrderListCount',
        param,
        resParams
    )
}

export function getUserActivityOrderTotalNum(param = {}, resParams) {
    // 订单列表总记录数 团购
    return request.post(
        'edcmanageapi/Marketing_userActivityOrderTotalNum',
        param,
        resParams
    )
}
export function delOrder(param = {}, resParams) {
    // 删除订单
    return request.post(
        '/edcmanageapi/LifePay_delOrder',
        param,
        resParams
    )
}
export function setOrderBookkeeping(param = {}, resParams) {
    // 对订单进行记账
    return request.post(
        '/edcmanageapi/LifePay_setOrderBookkeeping',
        param,
        resParams
    )
}


export function getMiniAppSubscribeMessageList(param = {}, resParams) {
    // 获取小程序订阅消息列表
    return request.post(
        'miniProgram/MiniAppProduce_getMiniAppSubscribeMessageListAll',
        param,
        resParams
    )
}

export function getMiniAppSubscribeMessageListAll(param = {}, resParams) {
    // 获取小程序未订阅消息列表
    return request.post(
        'miniProgram/MiniAppProduce_getMiniAppSubscribeMessageAll',
        param,
        resParams
    )
}

export function getMiniAppSubscribeMessageTemplateList(param = {}, resParams) {
    // 获取小程序订阅消息模板列表
    return request.post(
        'miniProgram/MiniAppProduce_miniAppSubscribeMessageTemplateList',
        param,
        resParams
    )
}
export function setOrderMark(param = {}, resParams) {
    // 对订单进行备注
    return request.post(
        '/edcmanageapi/LifePay_setOrderMark',
        param,
        resParams
    )
}


export function addMiniAppSubscribeMessage(param = {}, resParams) {
    // 添加小程序订阅消息模板
    return request.post(
        'miniProgram/MiniAppProduce_addMiniAppSubscribeMessage',
        param,
        resParams
    )
}
export function modifyMiniAppSubscribeMessage(param = {}, resParams) {
    // 添加和修改小程序订阅消息模板,支付宝可修改，微信不可修改
    return request.post(
        'miniProgram/MiniAppProduce_modifyMiniAppSubscribeMessage',
        param,
        resParams
    )
}
export function deleteMiniAppSubscribeMessage(param = {}, resParams) {
    // 刷除小程序订阅消息模
    return request.post(
        'miniProgram/MiniAppProduce_deleteMiniAppSubscribeMessage',
        param,
        resParams
    )
}

export function addBindOpenLink(param = {}, resParams) {
    // 添加外部链接跳转
    return request.post(
        'miniProgram/MiniAppProduce_addBindOpenLink',
        param,
        resParams
    )
}
export function addBindQrCode(param = {}, resParams) {
    // 添加外部链接跳转
    return request.post(
        'miniProgram/MiniAppProduce_addBindQrCode',
        param,
        resParams
    )
}
export function uniformQrCode(param = {}, resParams) {
    // 获取聚合二维码
    return request.post(
        'miniProgram/MiniAppProduce_uniformQrCode',
        param,
        resParams
    )
}

export function getDistributionConfig(param = {}, resParams) {
    // 获取分销配置
    return request.post(
        'edcmanageapi/Distribution_getConfig',
        param,
        resParams
    )
}

export function updateDistributionConfig(param = {}, resParams) {
    // 更新分销配置
    return request.post(
        'edcmanageapi/Distribution_updateConfig',
        param,
        resParams
    )
}
export function addDealer(param = {}, resParams) {
    // 开通分销
    return request.post(
        'edcmanageapi/Dealer_addDealer',
        param,
        resParams
    )
}
export function getDistributionList(param = {}, resParams) {
    // 分销列表
    return request.post(
        'edcmanageapi/Distribution_distributionRecordList',
        param,
        resParams
    )
}
export function getDistributionListCount(param = {}, resParams) {
    // 分销列表-页数
    return request.post(
        'edcmanageapi/Distribution_distributionRecordListCount',
        param,
        resParams
    )
}
export function exportDistributionRecordList(param = {}, resParams) {
    // 导出分销记录
    let sessionId = localStorage.getItem('sessionId')
    let userId = localStorage.getItem('userId')
    let paramNames = Object.keys(param)
    let url = request.baseUrl +
        '/edcmanageapi/Distribution_exportDistributionRecordList?sessionId=' + sessionId + "&userId=" + userId;
    paramNames.forEach(val => {
        if (param[val]) {
            url += `&${val}=${param[val]}`
        }
    })
    return url
}
export function exportDistributionRecordDetailList(param = {}, resParams) {
    // 导出分销商品列表
    let sessionId = localStorage.getItem('sessionId')
    let userId = localStorage.getItem('userId')
    let paramNames = Object.keys(param)
    let url = request.baseUrl +
        '/edcmanageapi/Distribution_exportDistributionRecordDetailList?sessionId=' + sessionId + "&userId=" + userId;
    paramNames.forEach(val => {
        if (param[val]) {
            url += `&${val}=${param[val]}`
        }
    })
    return url
}
export function getDealerListPage(param = {}, resParams) {
    // 店铺读取分销商列表-分页
    return request.post(
        'edcmanageapi/Dealer_dealerListPage',
        param,
        resParams
    )
}
export function getDealerChildCount(param = {}, resParams) {
    // 统计分销商下级数量 -总人数 单日新增人数  
    return request.post(
        'edcmanageapi/Dealer_dealerChildCount',
        param,
        resParams
    )
}
export function getDealerChildListPage(param = {}, resParams) {
    // 分销商的下级用户列表-分页
    return request.post(
        'edcmanageapi/Dealer_dealerChildListPage',
        param,
        resParams
    )
}
export function getDealerCode(param = {}, resParams) {
    // 获取分销码
    return request.post(
        'edcmanageapi/Dealer_getDealerCode',
        param,
        resParams
    )
}
export function sendRegisterSmsCode(param = {}, resParams) {
    // 待注册账号发送短信接口-闪送
    return request.post(
        'edcmanageapi/Shansong_sendRegisterSmsCode',
        param,
        resParams
    )
}
export function queryDDDeliverFee(param = {}, resParams) {
    // 查询订单运费-达达
    return request.post(
        'edcmanageapi/Dada_queryDeliverFee',
        param,
        resParams
    )
}
export function querySSDeliverFee(param = {}, resParams) {
    // 查询订单运费-闪送
    return request.post(
        'edcmanageapi/Shansong_queryDeliverFee',
        param,
        resParams
    )
}
export function addDDAfterQuery(param = {}, resParams) {
    // 查询运费后发单-达达
    return request.post(
        'edcmanageapi/Dada_addAfterQuery',
        param,
        resParams
    )
}
export function addSSAfterQuery(param = {}, resParams) {
    // 查询运费后发单-闪送
    return request.post(
        'edcmanageapi/Shansong_addAfterQuery',
        param,
        resParams
    )
}
export function cancelDadaOrder(param = {}, resParams) {
    // 取消达达订单-达达
    return request.post(
        'edcmanageapi/Dada_cancelDadaOrder',
        param,
        resParams
    )
}
export function orderCancelMYT(param = {}, resParams) {
    // 订单取消
    return request.post(
        'edcmanageapi/Maiyatian_orderCancel',
        param,
        resParams
    )
}
export function getDadaCancelReasons(param = {}, resParams) {
    // 获取取消原因-达达
    return request.post(
        'edcmanageapi/Dada_getCancelReasons',
        param,
        resParams
    )
}
export function cancelShansongOrder(param = {}, resParams) {
    // 取消闪送订单-闪送
    return request.post(
        'edcmanageapi/Shansong_cancelShansongOrder',
        param,
        resParams
    )
}
export function cancelEleOrder(param = {}, resParams) {
    // 取消美团订单-美团
    return request.post(
        'edcmanageapi/Ship_cancelEleOrder',
        param,
        resParams
    )
}
export function getDDOrderInfo(param = {}, resParams) {
    // 获取订单信息
    return request.post(
        'edcmanageapi/Dada_getOrderInfo',
        param,
        resParams
    )
}
export function getDDlogistics(param = {}, resParams) {
    // 获取配送的物流信息 
    return request.post(
        'edcmanageapi/Dada_getlogistics',
        param,
        resParams
    )
}

export function createDealerCode(param = {}, resParams) {
    // 获取小程序码 
    return request.post(
        'edcapi/Dealer_createDealerCode',
        param,
        resParams
    )
}

export function getAllStore(param = {}, resParams) {
    // 获取闪送店铺ID
    return request.post(
        'edcmanageapi/Shansong_getAllStore',
        param,
        resParams
    )
}

export function getMerchantMT(param = {}, resParams) {
    // 配送商家获取列表-美团
    return request.post(
        'edcmanageapi/Ship_getMerchant',
        param,
        resParams
    )
}

export function getMerchantMYT(param = {}, resParams) {
    // 查询麦芽田门店
    return request.post(
        'edcmanageapi/Maiyatian_getMerchant',
        param,
        resParams
    )
}
export function findWithdrawalApplyListPage(param = {}, resParams) {
    // 读取提现记录列表
    return request.post(
        'edcmanageapi/Dealer_findWithdrawalApplyListPage',
        param,
        resParams
    )
}
export function findWithdrawalApplyTotalNum(param = {}, resParams) {
    // 读取提现记录列表-分页
    return request.post(
        'edcmanageapi/Dealer_withdrawalApplyTotalNum',
        param,
        resParams
    )
}
export function updateWithdrawalApply(param = {}, resParams) {
    // 修改提现记录并拨款
    return request.post(
        'edcmanageapi/Dealer_updateWithdrawalApply',
        param,
        resParams
    )
}
export function getApplicationList(param = {}, resParams) {
    // 留言接口
    return request.post(
        'edcmanageapi/Message_getList',
        param,
        resParams
    )
}
export function updateApplicationApply(param = {}, resParams) {
    // 留言更改状态
    return request.post(
        'edcmanageapi/Message_updateMessage',
        param,
        resParams
    )
}

export function addPublishQrCodeJump(param = {}, resParams) {
    // 绑定普通二维码
    return request.post(
        'miniProgram/MiniAppProduce_addPublishQrCodeJump',
        param,
        resParams
    )
}

export function addQrCodeJumpTableNumber(param = {}, resParams) {
    // 生成二维码桌码
    return request.post(
        'miniProgram/MiniAppProduce_addQrCodeJumpTableNumber',
        param,
        resParams
    )
}
export function addQrCodeJumpPay(param = {}, resParams) {
    // 首页二维码(普通二维码)
    return request.post(
        'miniProgram/MiniAppProduce_addQrCodeJumpPay',
        param,
        resParams
    )
}
export function addQrCodeJumpIndex(param = {}, resParams) {
    // 快速付款二维码(普通二维码
    return request.post(
        'miniProgram/MiniAppProduce_addQrCodeJumpIndex',
        param,
        resParams
    )
}

export function createMiniApp(param = {}, resParams) {
    // 快速创建微信小程序
    return request.post(
        'miniProgram/MiniAppAuth_createMiniApp',
        param,
        resParams
    )
}

export function createDYMiniApp(param = {}, resParams) {
    // 快速创建抖音小程序
    return request.post(
        'miniProgram/DyMiniApp_createMiniApp',
        param,
        resParams
    )
}

export function getShopList(param = {}, resParams) {
    // 门店管理- 门店列表(后台管理)
    return request.post(
        'edcmanageapi/Shop_shopStores',
        param,
        resParams
    )
}
export function createShopNoticeMessage(param = {}, resParams) {
    // 商户手动推送消息 - 商户推给会员
    return request.post(
        'edcmanageapi/ShopNoticeMessage_createShopNoticeMessage',
        param,
        resParams
    )
}

export function getStoreList(param = {}, resParams) {
    // 已开通码点餐的分店列表
    return request.post(
        'edcmanageapi/Shop_edcStoreList',
        param,
        resParams
    )
}

export function getShopStoresTotalNum(param = {}, resParams) {
    // 门店列表门店记录数（后台管理）
    return request.post(
        'edcmanageapi/Shop_shopStoresTotalNum',
        param,
        resParams
    )
}
export function getShopNoticeMessageList(param = {}, resParams) {
    // 消息列表
    return request.post(
        'edcmanageapi/ShopNoticeMessage_shopNoticeMessageList',
        param,
        resParams
    )
}

export function createOrUpdateShopStore(param = {}, resParams) {
    // 创建、修改 分店
    return request.post(
        'edcmanageapi/Shop_createOrUpdateShopStore',
        param,
        resParams
    )
}

export function getUserInfo(param = {}, resParams) {
    // 获取当前登陆者的用户信息
    return request.post(
        'edcmanageapi/Shop_getUserInfo',
        param,
        resParams
    )
}
export function getShopNoticeMessageListCount(param = {}, resParams) {
    // 消息列表 - 记录数
    return request.post(
        'edcmanageapi/ShopNoticeMessage_shopNoticeMessageListCount',
        param,
        resParams
    )
}
export function dyShopAuthUrl(param = {}, resParams) {
    // 商户授权码url -抖音
    return request.post(
        'edcmanageapi/Marketing_dyShopAuthUrl',
        param,
        resParams
    )
}
export function checkBdmIsAuth(param = {}, resParams) {
    // 云推码 商户 是否授权 轮询
    return request.post(
        'edcmanageapi/Marketing_checkBdmIsAuth',
        param,
        resParams
    )
}
export function getBdmItemList(param = {}, resParams) {
    // 云推码资源列表
    return request.post(
        'edcmanageapi/Marketing_bdmItemList',
        param,
        resParams
    )
}

export function getFindReceiveOrWriteOffStatictic(param = {}, resParams) {
    // 统计券领取数量和核销数量
    return request.post(
        'edcmanageapi/CardCoupon_findReceiveOrWriteOffStatictic',
        param,
        resParams
    )
}

export function getShopMemberData(param = {}, resParams) {
    // 会员统计数据
    return request.post(
        'edcmanageapi/Member_getShopMemberData',
        param,
        resParams
    )
}

export function getFindDailyNewShopMemberNum(param = {}, resParams) {
    // 每日的会员注册数量
    return request.post(
        'edcmanageapi/Member_findDailyNewShopMemberNum',
        param,
        resParams
    )
}
export function getBdmItemListCount(param = {}, resParams) {
    // 云推码资源列表总记录数
    return request.post(
        'edcmanageapi/Marketing_bdmItemListCount',
        param,
        resParams
    )
}
export function delBdmItem(param = {}, resParams) {
    // 删除云推码资源
    return request.post(
        'edcmanageapi/Marketing_delBdmItem',
        param,
        resParams
    )
}
export function delBdmItemList(param = {}, resParams) {
    // 批量删除云推码资源
    return request.post(
        'edcmanageapi/Marketing_delBdmItemList',
        param,
        resParams
    )
}
export function addBdmItem(param = {}, resParams) {
    // 发布云推码资源
    return request.post(
        'edcmanageapi/Marketing_addBdmItem',
        param,
        resParams
    )
}
export function getMiniAppAllCategories(param = {}, resParams) {
    // 获取支付宝/微信支付 小程序类目树
    return request.post(
        'miniProgram/MiniAppAuth_miniAppAllCategories',
        param,
        resParams
    )
}
export function getMiniAppAllCategoriesDY(param = {}, resParams) {
    // 获取抖音小程序可以设置的服务类目列表
    return request.post(
        'miniProgram/DyMiniAppAuth_miniAppAllCategories',
        param,
        resParams
    )
}
export function addMiniAppAllCategoriesDY(param = {}, resParams) {
    // 增加抖音小程序服务类目
    return request.post(
        'miniProgram/DyMiniAppAuth_MiniAppAddCategories',
        param,
        resParams
    )
}
export function getMerchantStatusDY(param = {}, resParams) {
    // 获取抖音进件状态
    return request.post(
        'miniProgram/DyMiniAppProduce_getMerchantStatus',
        param,
        resParams
    )
}
export function putPayTokenDY(param = {}, resParams) {
    // 抖音小程序支付token
    return request.post(
        'miniProgram/DyMiniAppProduce_payToken',
        param,
        resParams
    )
}
export function getAppMerchantDY(param = {}, resParams) {
    // 抖音小程序支付进件
    return request.post(
        'miniProgram/DyMiniAppProduce_getAppMerchant',
        param,
        resParams
    )
}
export function modifyMiniAppInfo(param = {}, resParams) {
    // 修改基础小程序信息
    return request.post(
        'miniProgram/MiniAppAuth_modifyMiniAppInfo',
        param,
        resParams
    )
}
export function wxMiniAppAddCategories(param = {}, resParams) {
    // 添加微信小程序类目
    return request.post(
        'miniProgram/MiniAppAuth_wxMiniAppAddCategories',
        param,
        resParams
    )
}

export function getFindTopGoodsV2(param = {}, resParams) {
    // 销售排名商品
    return request.post(
        'edcmanageapi/Goods_findTopGoodsV2',
        param,
        resParams
    )
}

export function exportTopGoods(param = {}, resParams) {
    // 商品分析导出
    return request.post(
        'edcmanageapi/Goods_exportTopGoods',
        param,
        resParams
    )
}

export function getFindGoodsByTotalStockCount(param = {}, resParams) {
    // 库存预警列表
    return request.post(
        'edcmanageapi/Goods_findGoodsByTotalStockCount',
        param,
        resParams
    )
}

export function getAccessRecordForStatistics(param = {}, resParams) {
    // 访问趋势统计
    return request.post(
        'edcmanageapi/AccessRecord_accessRecordForStatistics',
        param,
        resParams
    )
}

export function getStatisticsOrdersByDates(param = {}, resParams) {
    // 订单统计明细--根据日期  
    return request.post(
        'edcmanageapi/Order_statisticsOrdersByDate',
        param,
        resParams
    )
}

export function getEdcShopTablesNumsV2(param = {}, resParams) {
    // 获取 店铺餐桌各个状态数量  
    return request.post(
        'edcmanageapi/Shop_getEdcShopTablesNumsV2',
        param,
        resParams
    )
}

export function getShopTablesForCockpit(param = {}, resParams) {
    // 桌位列表含状态 
    return request.post(
        'edcmanageapi/Shop_getShopTablesForCockpit',
        param,
        resParams
    )
}

export function getAllOrdersSimple(param = {}, resParams) {
    // 店铺的订单,简化版
    return request.post(
        'edcmanageapi/Order_allOrdersSimple',
        param,
        resParams
    )
}

export function getShopMemberActivityList(param = {}, resParams) {
    // 店铺的订单,简化版
    return request.post(
        'qrcapi/ShopMemberActivity_shopMemberActivityList',
        param,
        resParams
    )
}

export function shopMemberRecharge(param = {}, resParams) {
    // 会员充值
    return request.post(
        'qrcapi/ShopMember_shopMemberRecharge',
        param,
        resParams
    )
}

export function Pay_userPayScan(param = {}, resParams) {
    // 扫码充值 
    return request.post(
        'qrcapi/Pay_userPayScan',
        param,
        resParams
    )
}

export function UserImageBox_moveImg(param = {}, resParams) {
    // 改变图片对应的标签
    return request.post(
        'edcmanageapi/UserImageBox_moveImg',
        param,
        resParams
    )
}

export function getOemInfo(param = {}, resParams) {
    // oem信息
    return request.post(
        'edcmanageapi/Marketing_oemInfo',
        param,
        resParams
    )
}
export function getOemInstitution(param = {}, resParams) {
    // oem信息
    return request.post(
        'wfapi/AgenterOemInstitution_getXcxOemInstitution',
        param,
        resParams
    )
}

export function getOilGunList(param = {}, resParams) {
    // 油枪列表
    return request.post(
        'edcmanageapi/ShoppingTableCalcCost_shoppingTableCalcCostList',
        param,
        resParams
    )
}

export function getOilGunListCount(param = {}, resParams) {
    // 油枪列表 记录数
    return request.post(
        'edcmanageapi/ShoppingTableCalcCost_shoppingTableCalcCostListCount',
        param,
        resParams
    )
}

export function updateOilGun(param = {}, resParams) {
    // 创建油枪 绑定商品 一步到位
    return request.post(
        'edcmanageapi/ShoppingTableCalcCost_updateShoppingTableAndBindGood',
        param,
        resParams
    )
}

export function bindOilGun(param = {}, resParams) {
    // 油枪绑定商品
    return request.post(
        'edcmanageapi/ShoppingTableCalcCost_bindGasolineStationCalcCost',
        param,
        resParams
    )
}

export function deleteOilGun(param = {}, resParams) {
    // 油枪商品解绑 （已经绑定过的 需要先解绑）
    return request.post(
        'edcmanageapi/ShoppingTableCalcCost_deleteGasolineStationCalcCost',
        param,
        resParams
    )
}

export function findSaleShopWorks(param = {}, resParams) {
    // 油枪商品解绑 （已经绑定过的 需要先解绑）
    return request.post(
        'edcmanageapi/Shop_findSaleShopWorks',
        param,
        resParams
    )
}

export function modifyMemberWallet(param = {}, resParams) {
    // 扣会员里面的余额
    return request.post(
        'edcmanageapi/Member_modifyMemberWallet',
        param,
        resParams
    )
}
export function getTimeCardList(param = {}, resParams) {
    // 获取权益卡列表
    return request.post(
        'edcmanageapi/TimeCard_getList',
        param,
        resParams
    )
}

export function saveTimeCard(param = {}, resParams) {
    // 创建或者编辑权益卡
    return request.post(
        'edcmanageapi/TimeCard_saveTimeCard',
        param,
        resParams
    )
}
export function saveTimeMemberCard(param = {}, resParams) {
    // 会员发卡或者编辑
    return request.post(
        'edcmanageapi/TimeCard_saveTimeMemberCard',
        param,
        resParams
    )
}
export function increaseTimeMemberCardNum(param = {}, resParams) {
    // 增加会员次卡使用总数量
    return request.post(
        'edcmanageapi/TimeCard_increaseTimeMemberCardNum',
        param,
        resParams
    )
}
export function getTimeMemberCardList(param = {}, resParams) {
    // 获取会员次卡列表分页
    return request.post(
        'edcmanageapi/TimeCard_getTimeMemberCardList',
        param,
        resParams
    )
}
export function verifyRecord(param = {}, resParams) {
    // 次卡核销接口
    return request.post(
        'edcmanageapi/TimeCard_verifyRecord',
        param,
        resParams
    )
}
export function getTimeCardRecordList(param = {}, resParams) {
    // 使用核销记录列表分页
    return request.post(
        'edcmanageapi/TimeCard_getTimeCardRecordList',
        param,
        resParams
    )
}

export function getShopMemberData2(param = {}, resParams) {
    // 会员数据统计
    return request.post(
        'edcmanageapi/Member_getShopMemberData2',
        param,
        resParams
    )
}

export function excelRrechargeConsumList(param = {}, resParams) {
    // 会员消费导出
    return request.post(
        'edcmanageapi/Member_excelRrechargeConsumList',
        param,
        resParams
    )
}

export function getShopMemberApplyOrderList(param = {}, resParams) {
    // 会员申请列表
    return request.post(
        'edcmanageapi/ShopMember_shopMemberApplyOrderList',
        param,
        resParams
    )
}

export function findUserFuncInfo(param = {}, resParams) {
    //查询开通情况  新增功能类型(101.平台点餐小程序)
    return request.post(
        'edcmanageapi/UserFunc_findUserFuncInfo',
        param,
        resParams
    )
}

export function getShopMemberApplyOrderListCount(param = {}, resParams) {
    // 店铺会员申请列表--记录数
    return request.post(
        'edcmanageapi/ShopMember_shopMemberApplyOrderListCount',
        param,
        resParams
    )
}

export function bindWhdcQrCode(param = {}, resParams) {
    //绑定微火点餐二维码
    return request.post(
        'miniProgram/MiniAppProduce_bindWhdcQrCode',
        param,
        resParams
    )
}

export function getTableWxCode(param = {}, resParams) {
    //生成微信小程序桌位码
    return request.post(
        'miniProgram/MiniAppProduce_getTableWxCode',
        param,
        resParams
    )
}

export function handleShopMemberApplyOrder(param = {}, resParams) {
    // 操作申请记录
    return request.post(
        'edcmanageapi/ShopMember_handleShopMemberApplyOrder',
        param,
        resParams
    )
}

export function whdcQrCode(param = {}, resParams) {
    //获取微火点餐二维码
    return request.post(
        'miniProgram/MiniAppProduce_whdcQrCode',
        param,
        resParams
    )
}

export function getCustomIconList(param = {}, resParams) {
    //获取自定义图标
    return request.post(
        'edcmanageapi/CustomIcon_getList',
        param,
        resParams
    )
}

export function findGoodsSample(param = {}, resParams) {
    //获取模板商品列表
    return request.post(
        'edcmanageapi/Goods_findGoodsSample',
        param,
        resParams
    )
}

export function saveCustomIcon(param = {}, resParams) {
    //获取自定义图标
    return request.post(
        'edcmanageapi/CustomIcon_saveCustomIcon',
        param,
        resParams
    )
}

export function importSampleGoods(param = {}, resParams) {
    //批量增加商品
    return request.post(
        'edcmanageapi/Goods_importSampleGoods',
        param,
        resParams
    )
}

export function findConfigByShopId(param = {}, resParams) {
    //查询 商户-美业配置  
    return request.post(
        'edcmanageapi/Appointment_findConfigByShopId',
        param,
        resParams
    )
}

export function saveOrUpdateConfig(param = {}, resParams) {
    //保存或更新 商户-美业配置 
    return request.post(
        'edcmanageapi/Appointment_saveOrUpdateConfig',
        param,
        resParams
    )
}

export function appointmentOrderData(param = {}, resParams) {
    //预约看板列表
    return request.post(
        'edcmanageapi/Appointment_appointmentOrderData',
        param,
        resParams
    )
}

export function saveOrUpdateArtisans(param = {}, resParams) {
    //创建修改手艺人
    return request.post(
        'edcmanageapi/Artisans_saveOrUpdateArtisans',
        param,
        resParams
    )
}

export function delArtisans(param = {}, resParams) {
    //删除手艺人
    return request.post(
        'edcmanageapi/Artisans_updateArtisansForDel',
        param,
        resParams
    )
}

export function findArtisans(param = {}, resParams) {
    //手艺人列表
    return request.post(
        'edcmanageapi/Artisans_findArtisans',
        param,
        resParams
    )
}

export function findArtisansAll(param = {}, resParams) {
    //手艺人列表-all
    return request.post(
        'edcmanageapi/Artisans_findAllArtisansAppointmentStatus',
        param,
        resParams
    )
}

export function findArtisansCount(param = {}, resParams) {
    //手艺人列表--记录数
    return request.post(
        'edcmanageapi/Artisans_findArtisansCount',
        param,
        resParams
    )
}

export function artisansInfo(param = {}, resParams) {
    //手艺人详情
    return request.post(
        'edcmanageapi/Artisans_artisansInfo',
        param,
        resParams
    )
}

export function findArtisansAppointmentStatus(param = {}, resParams) {
    //手艺人 某日 可预约情况
    return request.post(
        'edcmanageapi/Artisans_findArtisansAppointmentStatus',
        param,
        resParams
    )
}

export function bindService(param = {}, resParams) {
    //手艺人关联服务
    return request.post(
        'edcmanageapi/Artisans_bindServices',
        param,
        resParams
    )
}

export function saveOrUpdateScheduling(param = {}, resParams) {
    //添加、修改班次 
    return request.post(
        'edcmanageapi/Scheduling_saveOrUpdateScheduling',
        param,
        resParams
    )
}
export function schedulingList(param = {}, resParams) {
    //查询班次列表
    return request.post(
        'edcmanageapi/Scheduling_schedulingList',
        param,
        resParams
    )
}
export function deleteScheduling(param = {}, resParams) {
    //删除班次
    return request.post(
        'edcmanageapi/Scheduling_deleteScheduling',
        param,
        resParams
    )
}
export function findSchedulingListNum(param = {}, resParams) {
    //班次列表记录数
    return request.post(
        'edcmanageapi/Scheduling_findSchedulingListNum',
        param,
        resParams
    )
}
export function findSchedulingRecordList(param = {}, resParams) {
    //排班记录列表
    return request.post(
        'edcmanageapi/Scheduling_findSchedulingRecordList',
        param,
        resParams
    )
}
export function findSchedulingRecordInfoV2(param = {}, resParams) {
    //班次排班 详情 组合返回多个排班
    return request.post(
        'edcmanageapi/Scheduling_findSchedulingRecordInfoV2',
        param,
        resParams
    )
}
export function saveSchedulingRecordForBatchV2(param = {}, resParams) {
    //批量 添加排班记录 -多班次
    return request.post(
        'edcmanageapi/Scheduling_saveSchedulingRecordForBatchV2',
        param,
        resParams
    )
}
export function appointmentOrderList(param = {}, resParams) {
    //预约单列表
    return request.post(
        'edcmanageapi/Appointment_appointmentOrderList',
        param,
        resParams
    )
}
export function appointmentOrderListCount(param = {}, resParams) {
    //预约单列表--记录数
    return request.post(
        'edcmanageapi/Appointment_appointmentOrderListCount',
        param,
        resParams
    )
}
export function saveOrUpdateAppointmentOrder(param = {}, resParams) {
    //添加更新预约单
    return request.post(
        'edcmanageapi/Appointment_saveOrUpdateAppointmentOrder',
        param,
        resParams
    )
}
export function subServiceOrder(param = {}, resParams) {
    //生成正式服务订单
    return request.post(
        'edcmanageapi/Order_subServiceOrder',
        param,
        resParams
    )
}
export function updateAppointmentOrderStatus(param = {}, resParams) {
    //取消占用、取消订单、确认到店功能
    return request.post(
        'edcmanageapi/Appointment_updateAppointmentOrderStatus',
        param,
        resParams
    )
}
export function appointmentOrderInfo(param = {}, resParams) {
    //预约表详情
    return request.post(
        'edcmanageapi/Appointment_appointmentOrderInfo',
        param,
        resParams
    )
}
export function findUserCashCoupons(param = {}, resParams) {
    //查找某用户在本店的优惠券
    return request.post(
        'edcmanageapi/CashCoupon_findUserCashCoupons',
        param,
        resParams
    )
}
export function subTimeCardOrder(param = {}, resParams) {
    //次卡下单
    return request.post(
        'edcmanageapi/Order_subTimeCardOrder',
        param,
        resParams
    )
}

export function orderInfo(param = {}, resParams) {
    //订单详情
    return request.post(
        'edcmanageapi/Order_orderInfo',
        param,
        resParams
    )
}

export function handleOrderForShopWorker(param = {}, resParams) {
    //店员处理订单  ---40.现金收款
    return request.post(
        'edcmanageapi/Order_handleOrderForShopWorker',
        param,
        resParams
    )
}

export function payByShopMemberCard(param = {}, resParams) {
    //会员买单
    return request.post(
        'edcmanageapi/Order_payByShopMemberCard',
        param,
        resParams
    )
}


export function userPayScan(param = {}, resParams) {
    //扫码买单
    return request.post(
        'edcmanageapi/ShoppingTableCalcCost_payByType',
        param,
        resParams
    )
}
export function payResult(param = {}, resParams) {
    //扫码买单-轮询
    return request.post(
        'api/MallOrder_payResult',
        param,
        resParams
    )
}

export function setOrderAllMark(param = {}, resParams) {
    //设置订单商户备注
    return request.post(
        'edcmanageapi/Order_setOrderMark',
        param,
        resParams
    )
}
export function findHangingOrderList(param = {}, resParams) {
    //挂单列表
    return request.post(
        'edcmanageapi/HangingOrder_findHangingOrderList',
        param,
        resParams
    )
}
export function cancelOrder(param = {}, resParams) {
    //取消挂单
    return request.post(
        'edcmanageapi/HangingOrder_cancelOrder',
        param,
        resParams
    )
}
export function saveOrUpdateHangingOrder(param = {}, resParams) {
    //创建、修改 挂单 
    return request.post(
        'edcmanageapi/HangingOrder_saveOrUpdateHangingOrder',
        param,
        resParams
    )
}
export function findHangingOrderInfo(param = {}, resParams) {
    //创建、修改 挂单 
    return request.post(
        'edcmanageapi/HangingOrder_findHangingOrderInfo',
        param,
        resParams
    )
}
export function updateOrderStatusByOrderCode(param = {}, resParams) {
    //核销预约单
    return request.post(
        'edcmanageapi/Appointment_updateOrderStatusByOrderCode',
        param,
        resParams
    )
}

export function closeShopStore(param = {}, resParams) {
    //关闭门店
    return request.post(
        'edcmanageapi/Shop_closeShopStore',
        param,
        resParams
    )
}

export function getWifiList(param = {}, resParams) {
    //获取wifi列表(根据店铺id)
    return request.post(
        'edcmanageapi/WifiList_wifiListPage',
        param,
        resParams
    )
}
export function getWifiListCount(param = {}, resParams) {
    //获取wifi列表(根据店铺id)-记录数
    return request.post(
        'edcmanageapi/WifiList_getWifiListCount',
        param,
        resParams
    )
}

export function addAndUpdateWifiList(param = {}, resParams) {
    //添加修改wifi列表
    return request.post(
        'edcmanageapi/WifiList_addAndUpdateWifiList',
        param,
        resParams
    )
}

export function deleteWifiList(param = {}, resParams) {
    //逻辑删除wifi
    return request.post(
        'edcmanageapi/WifiList_deleteWifiList',
        param,
        resParams
    )
}


export function wxMiniAppApplyPrivacy(param = {}, resParams) {
    //微信小程序手动申请地理位置接口
    return request.post(
        'miniProgram/MiniAppAuth_wxMiniAppApplyPrivacy',
        param,
        resParams
    )
}


export function wxMiniAppGetPrivacy(param = {}, resParams) {
    //查询申请地理位置接口状态
    return request.post(
        'miniProgram/MiniAppAuth_wxMiniAppGetPrivacy',
        param,
        resParams
    )
}


// export function uploadImg(param = {}, resParams) {
//   //图片上传地址
//   return request.customPost(
//     '/YmUpload_image',
//     param,
//     resParams,
//     'https://api.yichengshi.cn'
//   )
// }

export function delDealer(param = {}, resParams) {
    //删除分销团长
    return request.post(
        'edcmanageapi/Dealer_delDealer',
        param,
        resParams
    )
}

export function findStoreProductList(param = {}, resParams) {
    //获取商品规格列表
    return request.post(
        'edcmanageapi/Goods_findStoreProductList',
        param,
        resParams
    )
}
export function batchUpdateStock(param = {}, resParams) {
    //修改分店库存
    return request.post(
        'edcmanageapi/Goods_batchUpdateStock',
        param,
        resParams
    )
}
export function findMemberCardBenefit(param = {}, resParams) {
    //查找付费会员卡权益(网页后台)
    return request.post(
        'edcmanageapi/Member_findMemberCardBenefit',
        param,
        resParams
    )
}
export function updateMemberCardBenefit(param = {}, resParams) {
    //会员卡添加修改权益(网页后台)
    return request.post(
        'edcmanageapi/Member_updateMemberCardBenefit',
        param,
        resParams
    )
}
export function getTerraceShopList(param = {}, resParams) {
    //获取平台商户店铺列表信息
    return request.post(
        'edcmanageapi/TerraceShop_getTerraceShopList',
        param,
        resParams
    )
}
export function getTerraceShopInfo(param = {}, resParams) {
    //获取平台商户店铺信息
    return request.post(
        'edcmanageapi/TerraceShop_getTerraceShopInfo',
        param,
        resParams
    )
}
export function addTerraceShop(param = {}, resParams) {
    //添加平台商户店铺
    return request.post(
        'edcmanageapi/TerraceShop_addTerraceShop',
        param,
        resParams
    )
}
export function modifyTerraceShopInfo(param = {}, resParams) {
    //修改平台商户店铺信息
    return request.post(
        'edcmanageapi/TerraceShop_modifyShopInfo',
        param,
        resParams
    )
}
export function deleteTerraceShop(param = {}, resParams) {
    //删除商户店铺
    return request.post(
        'edcmanageapi/TerraceShop_deleteTerraceShop',
        param,
        resParams
    )
}
export function getNewsModulesList(param = {}, resParams) {
    //新闻分类列表
    return request.post(
        'edcmanageapi/MallConsulting_newsModulesList',
        param,
        resParams
    )
}
export function plusNewsModules(param = {}, resParams) {
    //添加新闻分类-功能
    return request.post(
        'edcmanageapi/MallConsulting_plusNewsModules',
        param,
        resParams
    )
}
export function modifyNewsModules(param = {}, resParams) {
    //修改分类 -功能
    return request.post(
        'edcmanageapi/MallConsulting_modifyNewsModules',
        param,
        resParams
    )
}
export function deleteNewsModules(param = {}, resParams) {
    //删除分类-功能
    return request.post(
        'edcmanageapi/MallConsulting_deleteNewsModules',
        param,
        resParams
    )
}
export function getNewsList(param = {}, resParams) {
    //新闻列表
    return request.post(
        'edcmanageapi/MallConsulting_newsList',
        param,
        resParams
    )
}
export function plusNews(param = {}, resParams) {
    //添加新闻-功能
    return request.post(
        'edcmanageapi/MallConsulting_plusNews',
        param,
        resParams
    )
}
export function modifyNews(param = {}, resParams) {
    //编辑新闻-功能
    return request.post(
        'edcmanageapi/MallConsulting_modifyNews',
        param,
        resParams
    )
}
export function deleteNews(param = {}, resParams) {
    //删除新闻-功能
    return request.post(
        'edcmanageapi/MallConsulting_deleteNews',
        param,
        resParams
    )
}
export function addQrCodeJumpParkingCoupon(param = {}, resParams) {
    //跳转停车劵列表
    return request.post(
        'edcmanageapi/MallConsulting_addQrCodeJumpParkingCoupon',
        param,
        resParams
    )
}
export function getDrawStyleList(param = {}, resParams) {
    //风格列表
    return request.post(
        'edcmanageapi/Aidraw_drawStyleList',
        param,
        resParams
    )
}
export function createAIDrawWork(param = {}, resParams) {
    //创建AI作品
    return request.post(
        'edcmanageapi/Aidraw_createAIDrawWork',
        param,
        resParams
    )
}
export function singleDrawWork(param = {}, resParams) {
    //查看作品详情，
    return request.post(
        'edcmanageapi/Aidraw_singleDrawWork',
        param,
        resParams
    )
}
export function createAiText(param = {}, resParams) {
    //ai 文案
    return request.post(
        'edcmanageapi/Aidraw_createAiText',
        param,
        resParams
    )
}
export function getMatrixCodeGroupList(param = {}, resParams) {
    //获取矩阵码所有分组
    return request.post(
        'edcmanageapi/Marketing_groupList',
        param,
        resParams
    )
}
export function delMatrixCodeGroup(param = {}, resParams) {
    //删除矩阵码分组
    return request.post(
        'edcmanageapi/Marketing_delGroup',
        param,
        resParams
    )
}

export function getGroupInfo(param = {}, resParams) {
    //矩阵码分组详情
    return request.post(
        'edcmanageapi/Marketing_groupInfo',
        param,
        resParams
    )
}

export function updateGroup(param = {}, resParams) {
    //创建矩阵码分组
    return request.post(
        'edcmanageapi/Marketing_createGroup',
        param,
        resParams
    )
}
export function getGroupMemberInfo(param = {}, resParams) {
    //矩阵码分组成员详情
    return request.post(
        'edcmanageapi/Marketing_groupMemberInfo',
        param,
        resParams
    )
}
export function delGroupMember(param = {}, resParams) {
    //删除矩阵码分组成员
    return request.post(
        'edcmanageapi/Marketing_delGroupMember',
        param,
        resParams
    )
}
export function batchPublishMatrixCode(param = {}, resParams) {
    //矩阵码批量生成
    return request.post(
        'edcmanageapi/Marketing_batchPublish',
        param,
        resParams
    )
}
export function getOrderInfoFromWX(param = {}, resParams) {
    //查询订单发货状态
    return request.post(
        'edcmanageapi/Order_getOrderInfoFromWX',
        param,
        resParams
    )
}
export function getDeliveryListFromWX(param = {}, resParams) {
    //运力公司列表
    return request.post(
        'edcmanageapi/Order_getDeliveryListFromWX',
        param,
        resParams
    )
}
export function uploadShippingInfoToWX(param = {}, resParams) {
    //发货信息录入
    return request.post(
        'edcmanageapi/Order_uploadShippingInfoToWX',
        param,
        resParams
    )
}

export function getCanteenList(param = {}, resParams) {
    //餐厅列表
    return request.post(
        'edcmanageapi/BigYard_findRestaurantDtoList',
        param,
        resParams
    )
}

export function getCanteenListCount(param = {}, resParams) {
    //餐厅列表记录数
    return request.post(
        'edcmanageapi/BigYard_findRestaurantDtoListCount',
        param,
        resParams
    )
}

export function editCanteen(param = {}, resParams) {
    //新增/修改餐厅
    return request.post(
        'edcmanageapi/BigYard_saveOrUpdateRestaurant',
        param,
        resParams
    )
}

export function deleteCanteen(param = {}, resParams) {
    //删除餐厅
    return request.post(
        'edcmanageapi/BigYard_delRestaurant',
        param,
        resParams
    )
}

export function getFloorList(param = {}, resParams) {
    //楼宇列表
    return request.post(
        'edcmanageapi/BigYard_findBuildingDtoList',
        param,
        resParams
    )
}

export function getFloorListCount(param = {}, resParams) {
    //楼宇列表记录数
    return request.post(
        'edcmanageapi/BigYard_findBuildingDtoListCount',
        param,
        resParams
    )
}

export function editFloor(param = {}, resParams) {
    //新增/修改楼宇
    return request.post(
        'edcmanageapi/BigYard_saveOrUpdateBuilding',
        param,
        resParams
    )
}

export function deleteFloor(param = {}, resParams) {
    //删除楼宇
    return request.post(
        'edcmanageapi/BigYard_delBuilding',
        param,
        resParams
    )
}

export function getRoomList(param = {}, resParams) {
    //获取房间列表
    return request.post(
        'edcmanageapi/BigYard_findRoomDtoList',
        param,
        resParams
    )
}

export function editRoom(param = {}, resParams) {
    //新增或修改房间
    return request.post(
        'edcmanageapi/BigYard_saveOrUpdateRoom',
        param,
        resParams
    )
}

export function deleteRoom(param = {}, resParams) {
    //删除房间
    return request.post(
        'edcmanageapi/BigYard_delRoom',
        param,
        resParams
    )
}

export function addLotteryActivity(param = {}, resParams) {
    //添加或更新活动
    return request.post(
        'edcmanageapi/LotteryDraw_addOrUpdateLotteryDrawActivity',
        param,
        resParams
    )
}

export function getLotteryList(param = {}, resParams) {
    //活动列表
    return request.post(
        'edcmanageapi/LotteryDraw_lotteryDrawActivityList',
        param,
        resParams
    )
}

export function getLotteryDetail(param = {}, resParams) {
    //活动详情
    return request.post(
        'edcmanageapi/LotteryDraw_activityDetail',
        param,
        resParams
    )
}

export function deleteLottery(param = {}, resParams) {
    //删除活动
    return request.post(
        'edcmanageapi/LotteryDraw_deleteActivity',
        param,
        resParams
    )
}

// 启用活动
export function enableActivity(param = {}, resParams) {
    return request.post(
        'edcmanageapi/LotteryDraw_enableActivity',
        param,
        resParams
    )
}

// 中奖记录
export function findLotteryRecordList(param = {}, resParams) {
    return request.post(
        'edcmanageapi/LotteryDraw_findLotteryRecordList',
        param,
        resParams
    )
}

// 兑换奖品
export function cashLotteryRecord(param = {}, resParams) {
    return request.post(
        'edcmanageapi/LotteryDraw_cashLotteryRecord',
        param,
        resParams
    )
}

// 商品单位列表
export function getGoodsUnitList(param = {}, resParams) {
    return request.post(
        'qrcapi/GoodsUnit_goodsUnitList',
        param,
        resParams
    )
}

// 调拨单审核
export function getNewstInfo(param = {}, resParams) {
    return request.post(
        'qrcapi/Repository_getNewstInfo',
        param,
        resParams
    )
}

// 供应商列表
export function supplierList(param = {}, resParams) {
    return request.post(
        'qrcapi/Supplier_supplierList',
        param,
        resParams
    )
}

// 供应商分类列表页数
export function supplierClassificationList(param = {}, resParams) {
    return request.post(
        'qrcapi/Supplier_supplierClassificationList',
        param,
        resParams
    )
}

// 供应商分类列表
export function supplierClassificationListTotal(param = {}, resParams) {
    return request.post(
        'qrcapi/SupplierCategory_listTotalNum',
        param,
        resParams
    )
}

// 添加分类
export function saveSupplierClassification(param = {}, resParams) {
    return request.post(
        'qrcapi/Supplier_saveSupplierClassification',
        param,
        resParams
    )
}

// 更新分类
export function modifySupplierClassification(param = {}, resParams) {
    return request.post(
        'qrcapi/Supplier_modifySupplierClassification',
        param,
        resParams
    )
}

// 删除分类
export function deleteSupplierClassification(param = {}, resParams) {
    return request.post(
        'qrcapi/Supplier_deleteSupplierClassification',
        param,
        resParams
    )
}

// 供应商列表页数
export function supplierListTotal(param = {}, resParams) {
    return request.post(
        'qrcapi/Supplier_listTotalNum',
        param,
        resParams
    )
}

// 添加新的供应商
export function saveSupplier(param = {}, resParams) {
    return request.post(
        'qrcapi/Supplier_saveSupplier',
        param,
        resParams
    )
}

// 修改供应商
export function modifySupplier(param = {}, resParams) {
    return request.post(
        'qrcapi/Supplier_modifySupplier',
        param,
        resParams
    )
}

// 盘点单列表总记录数和条件
export function GoodsCheckListTotalNum(param = {}, resParams) {
    return request.post(
        'qrcapi/GoodsCheck_listTotalNum',
        param,
        resParams
    )
}

// 经手人列表
export function Shop_handlerList(param = {}, resParams) {
    return request.post(
        'qrcapi/Shop_handlerList',
        param,
        resParams
    )
}

// 默认参数
export function defaultParam(param = {}, resParams) {
    return request.post(
        'qrcapi/Repository_defaultParam',
        param,
        resParams
    )
}

// 获取退款总金额
export function getRefundGoodsStatistic(param = {}, resParams) {
    return request.post(
        'qrcapi/RefundGoods_getRefundGoodsStatistic',
        param,
        resParams
    )
}

// 可用库存，库存总额合计
export function getRepositoryTotalStatistic(param = {}, resParams) {
    return request.post(
        'qrcapi/RepositoryGoodsDetail_getRepositoryTotalStatistic',
        param,
        resParams
    )
}

// 分类列表
export function goodsCategoryLists(param = {}, resParams) {
    return request.post(
        'qrcapi/GoodsCategory_goodsCategoryList',
        param,
        resParams
    )
}

// 调拨单列表
export function goodsChangeList(param = {}, resParams) {
    return request.post(
        'qrcapi/GoodsChange_goodsChangeList',
        param,
        resParams
    )
}

// 调拨单列表总记录数和条件
export function goodsChangeListTotalNum(param = {}, resParams) {
    return request.post(
        'qrcapi/GoodsChange_listTotalNum',
        param,
        resParams
    )
}

// 盘点单列表
export function goodsCheckList(param = {}, resParams) {
    return request.post(
        'qrcapi/GoodsCheck_goodsCheckList',
        param,
        resParams
    )
}

// 进货列表
export function goodsPurchaseList(param = {}, resParams) {
    return request.post(
        'qrcapi/PurchaseGoods_goodsPurchaseList',
        param,
        resParams
    )
}

// 进货列表总条数
export function goodsPurchaseListTotalNum(param = {}, resParams) {
    return request.post(
        'qrcapi/PurchaseGoods_listTotalNum',
        param,
        resParams
    )
}

// 是否锁定仓库
export function lockRepository(param = {}, resParams) {
    return request.post(
        'qrcapi/Repository_lockRepository',
        param,
        resParams
    )
}

// 进货退货单列表
export function refundGoodsList(param = {}, resParams) {
    return request.post(
        'qrcapi/RefundGoods_refundGoodsList',
        param,
        resParams
    )
}

// 进货退货单列表总数
export function refundGoodsListTotalNum(param = {}, resParams) {
    return request.post(
        'qrcapi/RefundGoods_listTotalNum',
        param,
        resParams
    )
}

// 库存查询列表
export function repositoryGoodsQueryList(param = {}, resParams) {
    return request.post(
        'qrcapi/RepositoryGoodsDetail_repositoryGoodsQueryList',
        param,
        resParams
    )
}

// 库存查询列表总记录数和条件
export function repositoryGoodsQuerylistTotalNum(param = {}, resParams) {
    return request.post(
        'qrcapi/RepositoryGoodsDetail_listTotalNum',
        param,
        resParams
    )
}

// 仓库列表
export function repositoryList(param = {}, resParams) {
    return request.post(
        'qrcapi/Repository_repositoryList',
        param,
        resParams
    )
}

// 商品列表
export function repositoryGoodsDetailList(param = {}, resParams) {
    return request.post(
        'qrcapi/RepositoryGoodsDetail_repositoryGoodsDetailList',
        param,
        resParams
    )
}

// 商品列表分页
export function goodslistTotalNumundGoods(param = {}, resParams) {
    return request.post(
        'qrcapi/RepositoryGoodsDetail_goodslistTotalNum',
        param,
        resParams
    )
}

// 更新拿货价
export function updateTakePrice(param = {}, resParams) {
    return request.post(
        'qrcapi/Goods_updateTakePrice',
        param,
        resParams
    )
}

// 作废盘点单
export function destroyGoodsCheck(param = {}, resParams) {
    return request.post(
        'qrcapi/GoodsCheck_destroyGoodsCheck',
        param,
        resParams
    )
}

// 单个盘点单详情
export function singleGoodsCheckAll(param = {}, resParams) {
    return request.post(
        'qrcapi/GoodsCheck_singleGoodsCheckAll',
        param,
        resParams
    )
}

// 单个商品的库存查询
export function singleQueryGoods(param = {}, resParams) {
    return request.post(
        'qrcapi/RepositoryGoodsDetail_singleQueryGoods',
        param,
        resParams
    )
}

// 调拨单审核
export function checkCJGoodsChange(param = {}, resParams) {
    return request.post(
        'qrcapi/GoodsChange_checkCJGoodsChange',
        param,
        resParams
    )
}

// 作废后审核完成，重置商品数量
export function checkDesChangeGoods(param = {}, resParams) {
    return request.post(
        'qrcapi/GoodsChange_checkDesChangeGoods',
        param,
        resParams
    )
}

// 单个调拨单详情
export function destroyChangeGoods(param = {}, resParams) {
    return request.post(
        'qrcapi/GoodsChange_destroyChangeGoods',
        param,
        resParams
    )
}

// 作废进货单
export function destroygoodsPurchase(param = {}, resParams) {
    return request.post(
        'qrcapi/PurchaseGoods_destroygoodsPurchase',
        param,
        resParams
    )
}

// 单个调拨单详情
export function enterGoodsChangeNotAll(param = {}, resParams) {
    return request.post(
        'qrcapi/GoodsChange_enterGoodsChangeNotAll',
        param,
        resParams
    )
}

// 部分商品入库
export function enterGoodsPurchaseNotAll(param = {}, resParams) {
    return request.post(
        'qrcapi/PurchaseGoods_enterGoodsPurchaseNotAll',
        param,
        resParams
    )
}

// 库存流水列表
export function repositoryFlowList(param = {}, resParams) {
    return request.post(
        'qrcapi/RepositoryFlow_repositoryFlowList',
        param,
        resParams
    )
}

// 库存流水列表总记录数和条件
export function repositoryFlowListTotalNum(param = {}, resParams) {
    return request.post(
        'qrcapi/RepositoryFlow_listTotalNum',
        param,
        resParams
    )
}

// 单个调拨单详情
export function singleGoodsChangeAll(param = {}, resParams) {
    return request.post(
        'qrcapi/GoodsChange_singleGoodsChangeAll',
        param,
        resParams
    )
}

// 查看单个进货单列表
export function singleGoodsPurchase(param = {}, resParams) {
    return request.post(
        'qrcapi/PurchaseGoods_singlePurchaseAll',
        param,
        resParams
    )
}

// 批量操作单位 排序、删除、启\禁用
export function batchUpdateUnit(param = {}, resParams) {
    return request.post(
        'qrcapi/GoodsUnit_batchUpdateUnit',
        param,
        resParams
    )
}

// 商品单位列表
export function goodsUnitList(param = {}, resParams) {
    return request.post(
        'qrcapi/GoodsUnit_goodsUnitList',
        param,
        resParams
    )
}

// 列表总记录数和条件
export function listTotalNum(param = {}, resParams) {
    return request.post(
        'qrcapi/GoodsUnit_listTotalNum',
        param,
        resParams
    )
}

// 添加商品单位
export function saveGoodsUnit(param = {}, resParams) {
    return request.post(
        'qrcapi/GoodsUnit_saveGoodsUnit',
        param,
        resParams
    )
}

// 员工列表
export function shopWorkersForType(param = {}, resParams) {
    return request.post(
        'qrcapi/Shop_shopWorkersForType',
        param,
        resParams
    )
}

// 退货订单详情
export function toRefundOrderDetail(param = {}, resParams) {
    return request.post(
        'qrcapi/MallOrder_toRefundOrderDetail',
        param,
        resParams
    )
}

// 保存线下订单备注
export function saveOrderMark(param = {}, resParams) {
    return request.post(
        'qrcapi/MallOrder_saveOrderMark',
        param,
        resParams
    )
}

// 商店列表
export function shopStores(param = {}, resParams) {
    return request.post(
        'qrcapi/Shop_shopStores',
        param,
        resParams
    )
}

// 订单列表
export function mallOrdersForManager(param = {}, resParams) {
    return request.post(
        'qrcapi/MallOrder_mallOrdersForManager',
        param,
        resParams
    )
}

// 订单列表
export function mallOrderProductPager(param = {}, resParams) {
    return request.post(
        'qrcapi/MallOrder_mallOrderProductPager',
        param,
        resParams
    )
}
// 订单详情列表
export function toManegerOrderDetail(param = {}, resParams) {
    return request.post(
        'qrcapi/MallOrder_toManegerOrderDetail',
        param,
        resParams
    )
}
// 退货订单详情
export function refundSelectProductList(param = {}, resParams) {
    return request.post(
        'qrcapi/MallOrder_refundSelectProductList',
        param,
        resParams
    )
}
// 员工列表
export function Shop_shopWorkers(param = {}, resParams) {
    return request.post(
        'qrcapi/Shop_shopWorkers',
        param,
        resParams
    )
}
// 销售退款商品入库
export function enterRefundGoods(param = {}, resParams) {
    return request.post(
        'qrcapi/RefundGoods_enterRefundGoods',
        param,
        resParams
    )
}
// 退款商品列表
export function findRefundGoodsList(param = {}, resParams) {
    return request.post(
        'qrcapi/MallOrder_findRefundGoodsList',
        param,
        resParams
    )
}
// 退货订单数，退货总金额
export function getRefundStatistic(param = {}, resParams) {
    return request.post(
        'qrcapi/MallOrder_getRefundStatistic',
        param,
        resParams
    )
}
// 退款商品列表总记录数
export function refundGoodsTotalNum(param = {}, resParams) {
    return request.post(
        'qrcapi/MallOrder_refundGoodsTotalNum',
        param,
        resParams
    )
}
// 创建销售退款单
export function saveMallOrderRefund(param = {}, resParams) {
    return request.post(
        'qrcapi/RefundGoods_saveMallOrderRefund',
        param,
        resParams
    )
}
// 添加\更新商品分类列表
export function createOrUpdateGoods(param = {}, resParams) {
    return request.post(
        'qrcapi/Goods_createOrUpdateGoods',
        param,
        resParams
    )
}
//保存盘点单
export function modifyOrSaveGoodsCheck(param = {}, resParams) {
    return request.post(
        'qrcapi/GoodsCheck_modifyOrSaveGoodsCheck',
        param,
        resParams
    )
}
//新增调拨单
export function saveGoodsChange(param = {}, resParams) {
    return request.post(
        'qrcapi/GoodsChange_saveGoodsChange',
        param,
        resParams
    )
}
//进货单创建
export function saveGoodsPurchase(param = {}, resParams) {
    return request.post(
        'qrcapi/PurchaseGoods_saveGoodsPurchase',
        param,
        resParams
    )
}
//确认结算
export function saveRefundGoods(param = {}, resParams) {
    return request.post(
        'qrcapi/RefundGoods_saveRefundGoods',
        param,
        resParams
    )
}
//退货进货单详情
export function singleReturnGoodsList(param = {}, resParams) {
    return request.post(
        'qrcapi/RefundGoods_singleRefundGoodsAll',
        param,
        resParams
    )
}
//作废退货进货单
export function destroyRefundGoods(param = {}, resParams) {
    return request.post(
        'qrcapi/RefundGoods_destroyRefundGoods',
        param,
        resParams
    )
}
//供应商详情
export function singleSupplier(param = {}, resParams) {
    return request.post(
        'qrcapi/Supplier_singleSupplier',
        param,
        resParams
    )
}
//关联进货单详情
export function singlePurchaseAll(param = {}, resParams) {
    return request.post(
        'qrcapi/PurchaseGoods_singlePurchaseAll',
        param,
        resParams
    )
}

//已有会员-获取绑定微信二维码
export function oldShopMemberBindWxCode(param = {}, resParams) {
    return request.post(
        'edcmanageapi/ShopMember_oldShopMemberBindWxCode',
        param,
        resParams
    )
}
//保存或更新页面数据
export function saveOrUpdateDecorationPageData(param = {}, resParams) {
    return request.post(
        'edcmanageapi/PageData_savaOrUpdatePageData',
        param,
        resParams
    )
}

//根据商户id获取已发布的最新一条数据
export function getDecorationPageData(param = {}, resParams) {
    return request.post(
        'edcmanageapi/PageData_getPageData',
        param,
        resParams
    )
}

//获取会员生日活动
export function findBirthdayActivity(param = {}, resParams) {
    return request.post(
        'edcmanageapi/Member_findBirthdayActivity',
        param,
        resParams
    )
}

//创建会员生日活动
export function createMemberBirthdayActivity(param = {}, resParams) {
    return request.post(
        'edcmanageapi/Member_createMemberBirthdayActivity',
        param,
        resParams
    )
}
// 核销团购券
export function postUpdateOrderStatusByGpOrder(param = {}, resParams) {
    return request.post(
        'edcmanageapi/Marketing_updateOrderStatusByGpOrder',
        param,
        resParams
    )
}
// 核销外卖 
export function postUpdateOrderStatusByWmOrder(param = {}, resParams) {
    return request.post(
        'edcmanageapi/Marketing_updateOrderStatusByWmOrder',
        param,
        resParams
    )
}

// 查询 美团/快手/抖音  核销门店
export function getMtMerchant(param = {}, resParams) {
    return request.post(
        'edcmanageapi/PoiLife_getMtMerchant',
        param,
        resParams
    )
}

// 查询 抖音门店poi列表
export function queryDyShopPoi(param = {}, resParams) {
    return request.post(
        'edcmanageapi/PoiLife_queryDyShopPoi',
        param,
        resParams
    )
}

// 查询 快手门店poi列表
export function queryKsShopPoi(param = {}, resParams) {
    return request.post(
        'edcmanageapi/PoiLife_queryKsShopPoi',
        param,
        resParams
    )
}

// 获取授权信息
export function getDyAuthUrl(param = {}, resParams) {
    return request.post(
        'edcmanageapi/PoiLife_getDyAuthUrl',
        param,
        resParams
    )
}
// 修改门店
export function updatePoiLifeMerchant(param = {}, resParams) {
    return request.post(
        'edcmanageapi/PoiLife_updateMerchant',
        param,
        resParams
    )
}
// 创建核销门店
export function addPoiLifeMerchant(param = {}, resParams) {
    return request.post(
        'edcmanageapi/PoiLife_addMerchant',
        param,
        resParams
    )
}

// 获取节假日调休日
export function getHoliday(param = {}, resParams) {
    return request.post(
        'edcmanageapi/Date_getHoliday',
        param,
        resParams
    )
}

// 动态价格记录列表
export function findGoodsDynamicPriceList(param = {}, resParams) {
    return request.post(
        'edcmanageapi/Goods_findGoodsDynamicPriceList',
        param,
        resParams
    )
}


// 动态价格--批量修改
export function saveOrUpdateBatchGoodsDynamicPrice(param = {}, resParams) {
    return request.post(
        'edcmanageapi/Goods_saveOrUpdateBatchGoodsDynamicPrice',
        param,
        resParams
    )
}

// 碰一碰 添加或更新配置
export function addOrUpdatePpCardItem(param = {}, resParams) {
    return request.post(
        'edcmanageapi/PpCard_addOrUpdatePpCardItem',
        param,
        resParams
    )
}

// 碰一碰 批量修改索引顺序
export function updatePpCardIdIndex(param = {}, resParams) {
    return request.post(
        'edcmanageapi/PpCard_updatePpCardIdIndex',
        param,
        resParams
    )
}

// 碰一碰 获取所有配置
export function findPpCardltems(param = {}, resParams) {
    return request.post(
        'edcmanageapi/PpCard_findPpCardltems',
        param,
        resParams
    )
}

// 碰一碰 删除配置
export function delPpCardId(param = {}, resParams) {
    return request.post(
        'edcmanageapi/PpCard_delPpCardId',
        param,
        resParams
    )
}

// 碰一碰 获取枚举类
export function findPpCardItemType(param = {}, resParams) {
    return request.post(
        'edcmanageapi/PpCard_findPpCardItemType',
        param,
        resParams
    )
}

// 碰一碰 获取列表
export function findPpCardNfc(param = {}, resParams) {
    return request.post(
        'edcapi/PpCard_findPpCardNfc',
        param,
        resParams
    )
}

// 碰一碰 分享链接
export function openSahreLinkForNfc(param = {}, resParams) {
    return request.post(
        'edcapi/PpCard_openSahreLinkForNfc',
        param,
        resParams
    )
}

// 碰一碰 抖音视频发布
export function publishDyVideoForNfc(param = {}, resParams) {
    return request.post(
        'edcapi/PpCard_publishDyVideoForNfc',
        param,
        resParams
    )
}

// 碰一碰 快手视频发布
export function publishKsVideoForNfc(param = {}, resParams) {
    return request.post(
        'edcapi/PpCard_publishKsVideoForNfc',
        param,
        resParams
    )
}

// 碰一碰 小红书视频发布
export function publishXhsVideoForNfc(param = {}, resParams) {
    return request.post(
        'edcapi/PpCard_publishXhsVideoForNfc',
        param,
        resParams
    )
}

// 碰一碰 微信、支付宝
export function publishWxOrZfbForNfc(param = {}, resParams) {
    return request.post(
        'edcapi/PpCard_openLinkForNfc',
        param,
        resParams
    )
}

// 碰一碰 小红书图文发布
export function publishXhsImagesForNfc(param = {}, resParams) {
    return request.post(
        'edcapi/PpCard_publishXhsImagesForNfc',
        param,
        resParams
    )
}

// 碰一碰 微信链接
export function openLinkWxWifiForNfc(param = {}, resParams) {
    return request.post(
        'edcapi/PpCard_openLinkWxWifiForNfc',
        param,
        resParams
    )
}

// 碰一碰 微信朋友圈
export function publishWxPyqForNfc(param = {}, resParams) {
    return request.post(
        'edcapi/PpCard_publishWxPyqForNfc',
        param,
        resParams
    )
}

// 碰一碰 携程发布图文
export function publishCtripImagesForNfc(param = {}, resParams) {
    return request.post(
        'edcapi/PpCard_publishCtripImagesForNfc',
        param,
        resParams
    )
}

// 碰一碰 创建AI文案
export function apiCreateAiText(param = {}, resParams) {
    return request.post(
        'edcmanageapi/PpCard_createAiText',
        param,
        resParams
    )
}

// 碰一碰 用户端重新创建AI文案
export function apiCreateAiTextForUser(param = {}, resParams) {
    return request.post(
        'edcapi/PpCard_createAiText',
        param,
        resParams
    )
}

// 碰一碰 用户端获取作品详情
export function findPpCardWorkDetail(param = {}, resParams) {
    return request.post(
        'edcapi/Aidraw_singleDrawWork',
        param,
        resParams
    )
}

// 碰一碰 用户端获取视频
export function findPpCardWorkVideo(param = {}, resParams) {
    return request.post(
        'edcapi/PpCard_publiwxVideoForNfc',
        param,
        resParams
    )
}

// 查看收款列表
export function getMoneyCodeList(param = {}, resParams) {
    return request.post(
        'wfapi/MoneyCode_moneyCodeList',
        param,
        resParams
    )
}

// 查看收款列表 记录数
export function getMoneyCodeListCount(param = {}, resParams) {
    return request.post(
        'wfapi/MoneyCode_moneyCodeListCount',
        param,
        resParams
    )
}


// 单个收款码
export function singleMoneyCode(param = {}, resParams) {
    return request.post(
        'wfapi/MoneyCode_singleMoneyCode',
        param,
        resParams
    )
}


// 修改收款码
export function modifyMoneyCode(param = {}, resParams) {
    return request.post(
        'wfapi/MoneyCode_modifyMoneyCode',
        param,
        resParams
    )
}


// 删除收款码
export function removeMoneyCode(param = {}, resParams) {
    return request.post(
        'wfapi/MoneyCode_removeMoneyCode',
        param,
        resParams
    )
}


// 查看开通功能详情
export function singleUserFuncInfo(param = {}, resParams) {
    return request.post(
        'wfapi/UserFunc_singleUserFuncInfo',
        param,
        resParams
    )
}

// 修改功能属性
export function modifyUserFuncInfo(param = {}, resParams) {
    return request.post(
        'wfapi/UserFunc_modifyUserFuncInfo',
        param,
        resParams
    )
}

// 查看设备列表
export function getPosTerminalList(param = {}, resParams) {
    return request.post(
        'wfapi/PosTerminal_posTerminalList',
        param,
        resParams
    )
}

// 查看设备列表 记录数
export function getPosTerminalListCount(param = {}, resParams) {
    return request.post(
        'wfapi/PosTerminal_posTerminalListCount',
        param,
        resParams
    )
}


// 单个设备
export function singlePosTerminal(param = {}, resParams) {
    return request.post(
        'wfapi/PosTerminal_singlePosTerminal',
        param,
        resParams
    )
}

// 修改设备
export function modifyPosTerminal(param = {}, resParams) {
    return request.post(
        'wfapi/PosTerminal_modifyPosTerminal',
        param,
        resParams
    )
}
// 添加收款码
export function createMoneyCode(param = {}, resParams) {
    return request.post(
        'wfapi/MoneyCode_createMoneyCode',
        param,
        resParams
    )
}
// 商家自助绑定终端（当前仅适用云音响产品）
export function bindPosTerminal(param = {}, resParams) {
    return request.post(
        'wfapi/PosTerminal_bindPosTerminal',
        param,
        resParams
    )
}
// 门店列表
export function getShopStoreList(param = {}, resParams) {
    return request.post(
        'wfapi/ShopStore_shopStoreList',
        param,
        resParams
    )
}


